webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cart__ = __webpack_require__(157);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);





/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    home: __WEBPACK_IMPORTED_MODULE_2__home__["a" /* default */],
    product: __WEBPACK_IMPORTED_MODULE_3__product__["a" /* default */],
    cart: __WEBPACK_IMPORTED_MODULE_4__cart__["a" /* default */]
  }
}));

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EDIT_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_ACTIVITY_ITEM; });
var ADD_TO_CART = 'ADD_TO_CART';
var EDIT_TO_CART = 'EDIT_TO_CART';
var DELETE_TO_CART = 'DELETE_TO_CART';
var CHECKOUT = 'CHECKOUT';
var SAVE_TO_CART = 'SAVE_TO_CART';
var SAVE_ACTIVITY_ITEM = 'SAVE_ACTIVITY_ITEM';

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_NEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_SLIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_COMPANIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATEUSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_FIRST_BUY; });
var LOGOUT = 'LOGOUT';
var LOGIN = 'LOGIN';
var SET_TOKEN = 'SET_TOKEN';
var SET_NEWS = 'SET_NEWS';
var SET_SLIDE = 'SET_SLIDE';
var SET_COMPANIES = 'SET_COMPANIES';
var UPDATEUSER = 'UPDATEUSER';
var CLEAR_FIRST_BUY = 'CLEAR_FIRST_BUY';

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_POPULAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADDON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SHARE_ID; });
var SET_PRODUCTS = 'SET_PRODUCTS';
var SET_POPULAR = 'SET_POPULAR';
var SET_ADDON = 'SET_ADDON';
var SET_SHARE_ID = 'SET_SHARE_ID';

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(14);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

var apiurl = 'https://affiliate.i80.com.tw';

if (window.localStorage) {
  var downData = false;
  var Today = new Date();
  Today = Today.getFullYear() + '-' + (Today.getMonth() + 1) + '-' + Today.getDate();
  var dataTime = new Date(window.localStorage.getItem('dataTime'));
  dataTime = dataTime.getFullYear() + '-' + (dataTime.getMonth() + 1) + '-' + dataTime.getDate();

  if (dataTime === null || Today !== dataTime) {
    downData = true;
  }

  var news = window.localStorage.getItem('news');
  if (news !== '' || news === 'null' || downData === true) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(apiurl + '/api/get_news').then(function (res) {
      var data = res.body.data;
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SET_NEWS', data);
    }, function () {
      console.log('Load news failed');
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SET_NEWS', JSON.parse(news));
  }

  var products = window.localStorage.getItem('products');
  if (products === '' || products === 'null' || downData === true) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(apiurl + '/api/getProduct').then(function (res) {
      var data = res.body.data;

      var product = [];
      for (var i = 0; i < data.length; i++) {
        var price = data[i].price + data[i].itemfee;
        var AnProduct = {
          id: data[i].id,
          fid: data[i].fid,
          name: data[i].name,
          price: price,
          oprice: data[i].oprice,
          firstprice: data[i].firstprice,
          point: data[i].point,
          imageM: data[i].imageM,
          imageL: data[i].imageL,
          showPrice: data[i].showPrice,
          content: data[i].content,
          sorting: data[i].lorder,
          quantity: 1,
          maximum: 20
        };
        product.push(AnProduct);
      }
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SET_PRODUCTS', product);
    }, function () {
      console.log('Load products failed');
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SET_PRODUCTS', JSON.parse(products));
  }

  var popular = window.localStorage.getItem('popular');
  if (popular === '' || popular === 'null' || downData === true) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(apiurl + '/api/getPopular').then(function (res) {
      var data = res.body.data;
      data.forEach(function (val, idx) {
        val.maximum = 1;
      });
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SET_POPULAR', data);
    }, function () {
      console.log('Load popular products failed');
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SET_POPULAR', JSON.parse(popular));
  }

  var addon = window.localStorage.getItem('addon');
  if (!addon || downData === true) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(apiurl + '/api/getAddonProduct').then(function (res) {
      var data = res.body.data;
      data.forEach(function (val, idx) {
        val.maximum = 1;
      });
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SET_ADDON', data);
    }, function () {
      console.log('Load addon products failed');
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SET_ADDON', JSON.parse(addon));
  }

  var companies = window.localStorage.getItem('companies');
  if (!companies || downData === true) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(apiurl + '/api/get_affiliate').then(function (res) {
      var data = res.body.data;
      var county = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getCounty;
      var district = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getDistrict;
      var CompanyArray = [];
      for (var i = 0; i < data.length; i++) {
        var CountyKey = data[i].county - 1;
        var CountyName = county[data[i].county] && data[i].county > 0 ? county[data[i].county].text : '';
        var DistrictName = '';
        if (data[i].county > 0) {
          DistrictName = district[CountyKey][data[i].district].text;
        }
        var CompanyData = {
          c_website: data[i].c_website,
          website_intro: data[i].website_intro,
          category_detail: data[i].category_detail,
          category_main: data[i].category_main,
          com_address: data[i].com_address,
          com_image: data[i].com_image,
          com_name: data[i].com_name,
          com_phone: data[i].com_phone,
          com_resize_image: data[i].com_resize_image,
          com_shopping: data[i].com_shopping,
          comid: data[i].comid,
          county: data[i].county,
          county_name: CountyName,
          district: data[i].district,
          district_name: DistrictName,
          delivery: data[i].delivery,
          free_delivery: data[i].free_delivery,
          free_delivery_set: data[i].free_delivery_set,
          lat: data[i].lat,
          lon: data[i].lon,
          m_factoryID: data[i].m_factoryID
        };
        CompanyArray.push(CompanyData);
      }
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SET_COMPANIES', CompanyArray);
    }, function () {
      console.log('Load companies failed');
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SET_COMPANIES', JSON.parse(companies));
  }

  var cart = window.localStorage.getItem('cart');
  if (cart !== '' && cart !== null) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SAVE_TO_CART', JSON.parse(cart));
  } else if (cart === 'null') {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('SAVE_TO_CART', []);
  }
} else {
  console.log('不支援暫時存取服務。');
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_register_service_worker__ = __webpack_require__(239);




if (true) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_register_service_worker__["a" /* register */])(__webpack_require__.i({"NODE_ENV":"production"}).BASE_URL + 'service-worker.js', {
    ready: function ready() {
      console.log('App is being served from cache by a service worker.\n' + 'For more details, visit https://goo.gl/AFskqB');
    },
    registered: function registered() {
      console.log('Service worker has been registered.');
    },
    cached: function cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound: function updatefound() {
      console.log('New content is downloading.');
    },
    updated: function updated() {
      console.log('New content is available; please refresh.');
    },
    offline: function offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error: function error(_error) {
      console.error('Error during service worker registration:', _error);
    }
  });
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_Main__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_News__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_News___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_News__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewsDetail__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewsDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_NewsDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Product__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Store__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_StoreView__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_StoreView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_StoreView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Register__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Member_Active__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Member_Active___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Member_Active__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Forgotpass__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Forgotpass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Forgotpass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_About__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Privacy__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Privacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Apply__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_FreeTrial__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_FreeTrial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_FreeTrial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Operators__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ProductView__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ProductView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_ProductView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_StoreProductView__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_StoreProductView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_StoreProductView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SearchProduct__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SearchProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_SearchProduct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_GoodPrice__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_GoodPrice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_GoodPrice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ShoppingCart__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ShoppingCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_ShoppingCart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Member_Member__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Member_Member___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Member_Member__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Member_Order__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Member_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Member_Order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Member_Consume__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Member_Consume___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Member_Consume__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Member_Bonus__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Member_Bonus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Member_Bonus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Member_Team__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Member_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Member_Team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Member_Training__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Member_Training___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Member_Training__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Member_Share__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Member_Share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Member_Share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Member_Agreement__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Member_Agreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Member_Agreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Member_Redeen__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Member_Redeen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Member_Redeen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Faq__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Faq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Faq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Contact__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Member_Personal__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Member_Personal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Member_Personal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Member_Performance__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Member_Performance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Member_Performance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_ResetPassword__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_MemberPolicy__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_MemberPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_MemberPolicy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Success__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Success__);







































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  name: '首頁',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Home_Main___default.a
}, {
  path: '/Login',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Home_Main___default.a,
  name: '登入'
}, {
  path: '/register',
  component: __WEBPACK_IMPORTED_MODULE_8__components_Register___default.a,
  name: '註冊',
  description: '註冊'
}, {
  path: '/forgotpass',
  component: __WEBPACK_IMPORTED_MODULE_10__components_Forgotpass___default.a,
  name: '忘記密碼',
  description: '忘記密碼'
}, {
  path: '/ResetPassword/:token',
  component: __WEBPACK_IMPORTED_MODULE_34__components_ResetPassword___default.a,
  name: '重設密碼',
  description: '重設密碼'
}, {
  path: '/Success',
  component: __WEBPACK_IMPORTED_MODULE_36__components_Success___default.a,
  name: '訂購完成',
  description: '訂購完成'
}, {
  path: '/register/:id',
  component: __WEBPACK_IMPORTED_MODULE_8__components_Register___default.a
}, {
  path: '/about',
  component: __WEBPACK_IMPORTED_MODULE_11__components_About___default.a,
  name: '關於我們'
}, {
  path: '/privacy',
  component: __WEBPACK_IMPORTED_MODULE_12__components_Privacy___default.a,
  name: '隱私權政策'
}, {
  path: '/member_policy',
  component: __WEBPACK_IMPORTED_MODULE_35__components_MemberPolicy___default.a,
  name: '會員條款'
}, {
  path: '/operators',
  component: __WEBPACK_IMPORTED_MODULE_15__components_Operators___default.a,
  name: '聯盟經營者'
}, {
  path: '/apply',
  component: __WEBPACK_IMPORTED_MODULE_13__components_Apply___default.a,
  name: '加入聯盟'
}, {
  path: '/freetrial',
  component: __WEBPACK_IMPORTED_MODULE_14__components_FreeTrial___default.a,
  name: '免費加入平台'
}, {
  path: '/active/:id/:verifycode',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Member_Active___default.a,
  name: '用戶啟動'
}, {
  path: '/member',
  component: __WEBPACK_IMPORTED_MODULE_21__components_Member_Member___default.a,
  meta: { requiresAuth: true },
  children: [{
    path: 'personal',
    component: __WEBPACK_IMPORTED_MODULE_32__components_Member_Personal___default.a,
    name: '個人資料中心',
    meta: { requiresAuth: true }
  }, {
    path: 'consume',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Member_Consume___default.a,
    name: '消費紀錄',
    meta: { requiresAuth: true }
  }, {
    path: 'Order',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Member_Order___default.a,
    name: '訂單紀錄',
    meta: { requiresAuth: true }
  }, {
    path: 'performance',
    component: __WEBPACK_IMPORTED_MODULE_33__components_Member_Performance___default.a,
    name: '績效查詢',
    meta: { requiresAuth: true }
  }, {
    path: 'bonus',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Member_Bonus___default.a,
    name: '回饋金查詢',
    meta: { requiresAuth: true }
  }, {
    path: 'team',
    component: __WEBPACK_IMPORTED_MODULE_25__components_Member_Team___default.a,
    name: '組織查詢',
    meta: { requiresAuth: true }
  }, {
    path: 'redeen',
    component: __WEBPACK_IMPORTED_MODULE_29__components_Member_Redeen___default.a,
    name: '抵用券',
    meta: { requiresAuth: true }
  }, {
    path: 'training',
    component: __WEBPACK_IMPORTED_MODULE_26__components_Member_Training___default.a,
    name: '培訓專區',
    meta: { requiresAuth: true }
  }, {
    path: 'share',
    component: __WEBPACK_IMPORTED_MODULE_27__components_Member_Share___default.a,
    name: '分享網址',
    meta: { requiresAuth: true }
  }, {
    path: 'agreement',
    component: __WEBPACK_IMPORTED_MODULE_28__components_Member_Agreement___default.a,
    name: '合約中心',
    meta: { requiresAuth: true }
  }]
}, {
  path: '/cart',
  component: __WEBPACK_IMPORTED_MODULE_20__components_ShoppingCart___default.a,
  name: '購物車'
}, {
  path: '/news',
  component: __WEBPACK_IMPORTED_MODULE_3__components_News___default.a,
  children: [{
    path: 'detail',
    component: __WEBPACK_IMPORTED_MODULE_4__components_NewsDetail___default.a,
    name: '最新消息'
  }]
}, {
  path: '/news/:id',
  component: __WEBPACK_IMPORTED_MODULE_4__components_NewsDetail___default.a
}, {
  name: '產品',
  path: '/product',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Product___default.a
}, {
  name: '產品詳細資訊',
  path: '/product/:id',
  component: __WEBPACK_IMPORTED_MODULE_16__components_ProductView___default.a
}, {
  name: '商家產品詳細資訊',
  path: '/store/product/:id/:fid',
  component: __WEBPACK_IMPORTED_MODULE_17__components_StoreProductView___default.a
}, {
  name: '商家產品/會員分享',
  path: '/store/product/:id/:fid/:shareid',
  component: __WEBPACK_IMPORTED_MODULE_17__components_StoreProductView___default.a
}, {
  name: '商品查詢',
  path: '/search/product',
  component: __WEBPACK_IMPORTED_MODULE_18__components_SearchProduct___default.a
}, {
  name: '愛幫您產品詳細，會員分享',
  path: '/product/:id/:shareid',
  component: __WEBPACK_IMPORTED_MODULE_16__components_ProductView___default.a
}, {
  name: '首購商品推廣畫面',
  path: '/goodprice/:id',
  component: __WEBPACK_IMPORTED_MODULE_19__components_GoodPrice___default.a
}, {
  name: '聯盟店家',
  path: '/store',
  component: __WEBPACK_IMPORTED_MODULE_6__components_Store___default.a
}, {
  name: '聯盟店家詳細',
  path: '/store/:id',
  component: __WEBPACK_IMPORTED_MODULE_7__components_StoreView___default.a
}, {
  name: 'FAQ',
  path: '/faq',
  component: __WEBPACK_IMPORTED_MODULE_30__components_Faq___default.a
}, {
  name: 'Contact',
  path: '/contact',
  component: __WEBPACK_IMPORTED_MODULE_31__components_Contact___default.a
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Home_Main___default.a
}];
/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_paginate__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookies__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_social_sharing__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_meta_info__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_meta_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_meta_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__registerServiceWorker__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(148);













__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_meta_info___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_social_sharing___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_paginate___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.devtools = true;

var apiurl = 'https://affiliate.i80.com.tw';

var token = localStorage.getItem('token');
if (token) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(apiurl + '/api/checkToken', {
    token: token,
    source_from: 'web'
  }).then(function (res) {
    var data = res.body.data;
    if (data.status === 200) {
      var user = {
        userId: localStorage.getItem('userId'),
        userName: localStorage.getItem('userName'),
        userEmail: localStorage.getItem('userEmail'),
        userPhone: localStorage.getItem('userPhone'),
        userCounty: localStorage.getItem('userCounty'),
        userDistrict: localStorage.getItem('userDistrict'),
        userAddress: localStorage.getItem('userAddress'),
        userCash: localStorage.getItem('userCash'),
        userValid: localStorage.getItem('userValid'),
        userStock: localStorage.getItem('userStock'),
        token: localStorage.getItem('token'),
        firstbuy: localStorage.getItem('firstbuy')
      };
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('LOGIN', user);
    } else {
      window.alert('您的登入時間已經到期，請重新登入會員。');
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('LOGOUT');
    }
  }, function () {
    console.log('Load user token');
  });
}




if (__WEBPACK_IMPORTED_MODULE_11__data__["default"]) {
  console.log('Load Success');
}

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers.common['Authorization'] = 'Basic YXBpOnBhc3N3b3Jk';

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'history',
  base: __dirname,
  routes: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.home.token === undefined) {
      console.log('Not authenticated');
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  router: router
}, __WEBPACK_IMPORTED_MODULE_2__components_App___default.a));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations_types_js__ = __webpack_require__(17);


/* harmony default export */ __webpack_exports__["a"] = ({
  ADD_TO_CART: function ADD_TO_CART(_ref, data) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["a" /* ADD_TO_CART */], data);
  },
  SAVE_ACTIVITY_ITEM: function SAVE_ACTIVITY_ITEM(_ref2, data) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["c" /* SAVE_ACTIVITY_ITEM */], data);
  },
  EDIT_TO_CART: function EDIT_TO_CART(_ref3, data) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["d" /* EDIT_TO_CART */], data);
  },
  DELETE_TO_CART: function DELETE_TO_CART(_ref4, data) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["e" /* DELETE_TO_CART */], data);
  },
  CHECKOUT: function CHECKOUT(_ref5, data) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["f" /* CHECKOUT */], data);
  },
  SAVE_TO_CART: function SAVE_TO_CART(_ref6, data) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["b" /* SAVE_TO_CART */], data);
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getCart: function getCart(state) {
    return state.cartlist;
  },
  getActivityItem: function getActivityItem(state) {
    return state.activityitem;
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js__ = __webpack_require__(156);




var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = ({
  state: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["a" /* state */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["b" /* mutations */],
  strict: debug
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__ = __webpack_require__(17);



var _mutations;



var state = {
  cartlist: [],
  activityitem: [],
  checkoutStatus: null
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["a" /* ADD_TO_CART */], function (state, data) {
  var record = '';
  var fid = '';
  if (state.cartlist.length > 0) {
    record = state.cartlist.find(function (p) {
      return p.id === data.id;
    });
    fid = state.cartlist.find(function (p) {
      return p.fid === data.fid;
    });
  }
  if (fid || fid === '') {
    if (!record) {
      var temp = {
        id: data.id,
        name: data.name,
        price: data.price,
        point: data.point,
        quantity: data.quantity,
        fid: data.fid,
        imageL: data.imageL,
        maximum: 20
      };
      state.cartlist.push(temp);
    } else {
      if (data.quantity < record.quantity) {
        if (data.quantity > 1) {
          record.quantity += data.quantity;
        } else {
          record.quantity++;
        }
      }
    }
    window.localStorage.setItem('cart', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.cartlist));
  } else {
    window.alert('請先結帳後再進行其他店家的購物');
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["b" /* SAVE_TO_CART */], function (state, data) {
  state.cartlist = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["c" /* SAVE_ACTIVITY_ITEM */], function (state, data) {
  state.activityitem.push(data);
  window.localStorage.setItem('activityitem', data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["d" /* EDIT_TO_CART */], function (state, data) {
  state.cartlist = data;
  window.localStorage.setItem('cart', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.cartlist));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["e" /* DELETE_TO_CART */], function (state, data) {
  state.cartlist.splice(state.cartlist.indexOf(data), 1);

  window.localStorage.setItem('cart', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.cartlist));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["f" /* CHECKOUT */], function (state, data) {
  localStorage.setItem('cart', []);
  state.cartlist = [];
}), _mutations);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations_types_js__ = __webpack_require__(18);

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_TOKEN: function SET_TOKEN(_ref, token) {
    var commit = _ref.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["a" /* SET_TOKEN */], token);
  },
  LOGIN: function LOGIN(_ref2, param) {
    var commit = _ref2.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["e" /* LOGIN */], { data: param });
  },
  LOGOUT: function LOGOUT(_ref3) {
    var commit = _ref3.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["b" /* LOGOUT */]);
  },
  SET_NEWS: function SET_NEWS(_ref4, news) {
    var commit = _ref4.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["f" /* SET_NEWS */], news);
  },
  SET_SLIDE: function SET_SLIDE(_ref5, slide) {
    var commit = _ref5.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["h" /* SET_SLIDE */], slide);
  },
  SET_COMPANIES: function SET_COMPANIES(_ref6, companies) {
    var commit = _ref6.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["g" /* SET_COMPANIES */], companies);
  },
  UPDATEUSER: function UPDATEUSER(_ref7, param) {
    var commit = _ref7.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["d" /* UPDATEUSER */], { data: param });
  },
  CLEAR_FIRST_BUY: function CLEAR_FIRST_BUY(_ref8, param) {
    var commit = _ref8.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["c" /* CLEAR_FIRST_BUY */], { data: param });
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getAPI: function getAPI(state) {
    return state.apiurl;
  },
  getMemberAPI: function getMemberAPI(state) {
    return state.memberurl;
  },
  getNews: function getNews(state) {
    return state.news;
  },
  getSlide: function getSlide(state) {
    return state.slide;
  },
  getCompanies: function getCompanies(state) {
    return state.companies;
  },
  getUserID: function getUserID(state) {
    return state.userId;
  },
  getUserName: function getUserName(state) {
    return state.userName;
  },
  getUserPhone: function getUserPhone(state) {
    return state.userPhone;
  },
  getUserCounty: function getUserCounty(state) {
    return state.userCounty;
  },
  getUserDistrict: function getUserDistrict(state) {
    return state.userDistrict;
  },
  getUserAddress: function getUserAddress(state) {
    return state.userAddress;
  },
  getUserEmail: function getUserEmail(state) {
    return state.userEmail;
  },
  getUserCash: function getUserCash(state) {
    return state.userCash;
  },
  getToken: function getToken(state) {
    return state.token;
  },
  getUserValid: function getUserValid(state) {
    return state.userValid;
  },
  getCounty: function getCounty(state) {
    return state.county;
  },
  getDistrict: function getDistrict(state) {
    return state.district;
  },
  getFirstbuy: function getFirstbuy(state) {
    return state.firstbuy;
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_js__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js__ = __webpack_require__(160);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["a" /* state */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["b" /* mutations */],
  strict: true
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__ = __webpack_require__(18);



var _mutations;



var state = {
  userId: '',
  userName: '',
  userEmail: '',
  userPhone: '',
  userCounty: '',
  userDistrict: '',
  userAddress: '',
  userCash: 0,
  userValid: 0,
  userStock: 0,
  firstbuy: 1,
  token: '',
  apiurl: 'https://affiliate.i80.com.tw/api/v1',
  memberurl: 'https://affiliate.i80.com.tw/api/m1',
  authenticated: false,
  news: [],
  slide: {},
  companies: {},
  county: [{ text: '請選擇', value: 0 }, { text: '基隆市', value: 1 }, { text: '台北市', value: 2 }, { text: '新北市', value: 3 }, { text: '桃園市', value: 4 }, { text: '新竹市', value: 5 }, { text: '新竹縣', value: 6 }, { text: '苗栗縣', value: 7 }, { text: '台中市', value: 8 }, { text: '彰化縣', value: 9 }, { text: '南投縣', value: 10 }, { text: '雲林縣', value: 11 }, { text: '嘉義市', value: 12 }, { text: '嘉義縣', value: 13 }, { text: '台南市', value: 14 }, { text: '高雄市', value: 15 }, { text: '屏東縣', value: 16 }, { text: '台東縣', value: 17 }, { text: '花蓮縣', value: 18 }, { text: '宜蘭縣', value: 19 }, { text: '澎湖縣', value: 20 }, { text: '金門縣', value: 21 }, { text: '連江縣', value: 22 }],
  district: [[{ text: '請選擇', value: 0 }, { text: '仁愛區', value: 1 }, { text: '信義區', value: 2 }, { text: '中正區', value: 3 }, { text: '中山區', value: 4 }, { text: '安樂區', value: 5 }, { text: '暖暖區', value: 6 }, { text: '七堵區', value: 7 }], [{ text: '請選擇', value: 0 }, { text: '中正區', value: 1 }, { text: '大同區', value: 2 }, { text: '中山區', value: 3 }, { text: '松山區', value: 4 }, { text: '大安區', value: 5 }, { text: '萬華區', value: 6 }, { text: '信義區', value: 7 }, { text: '士林區', value: 8 }, { text: '北投區', value: 9 }, { text: '內湖區', value: 10 }, { text: '南港區', value: 11 }, { text: '文山區', value: 12 }], [{ text: '請選擇', value: 0 }, { text: '萬里區', value: 1 }, { text: '金山區', value: 2 }, { text: '板橋區', value: 3 }, { text: '汐止區', value: 4 }, { text: '深坑區', value: 5 }, { text: '石碇區', value: 6 }, { text: '瑞芳區', value: 7 }, { text: '平溪區', value: 8 }, { text: '雙溪區', value: 9 }, { text: '貢寮區', value: 10 }, { text: '新店區', value: 11 }, { text: '坪林區', value: 12 }, { text: '烏來區', value: 13 }, { text: '永和區', value: 14 }, { text: '中和區', value: 15 }, { text: '土城區', value: 16 }, { text: '三峽區', value: 17 }, { text: '樹林區', value: 18 }, { text: '鶯歌區', value: 19 }, { text: '三重區', value: 20 }, { text: '新莊區', value: 21 }, { text: '泰山區', value: 22 }, { text: '林口區', value: 23 }, { text: '蘆洲區', value: 24 }, { text: '五股區', value: 25 }, { text: '八里區', value: 26 }, { text: '淡水區', value: 27 }, { text: '三芝區', value: 28 }, { text: '石門區', value: 29 }], [{ text: '請選擇', value: 0 }, { text: '中壢區', value: 1 }, { text: '平鎮區', value: 2 }, { text: '龍潭區', value: 3 }, { text: '楊梅區', value: 4 }, { text: '新屋區', value: 5 }, { text: '觀音區', value: 6 }, { text: '桃園區', value: 7 }, { text: '龜山區', value: 8 }, { text: '八德區', value: 9 }, { text: '大溪區', value: 10 }, { text: '復興區', value: 11 }, { text: '大園區', value: 12 }, { text: '蘆竹區', value: 13 }], [{ text: '請選擇', value: 0 }, { text: '東區', value: 1 }, { text: '北區', value: 2 }, { text: '香山區', value: 3 }], [{ text: '請選擇', value: 0 }, { text: '竹北市', value: 1 }, { text: '湖口鄉', value: 2 }, { text: '新豐鄉', value: 3 }, { text: '新埔鎮', value: 4 }, { text: '關西鎮', value: 5 }, { text: '芎林鄉', value: 6 }, { text: '寶山鄉', value: 7 }, { text: '竹東鎮', value: 8 }, { text: '五峰鄉', value: 9 }, { text: '橫山鄉', value: 10 }, { text: '尖石鄉', value: 11 }, { text: '北埔鄉', value: 12 }, { text: '峨眉鄉', value: 13 }], [{ text: '請選擇', value: 0 }, { text: '竹南鎮', value: 1 }, { text: '頭份鎮', value: 2 }, { text: '三灣鄉', value: 3 }, { text: '南庄鄉', value: 4 }, { text: '獅潭鄉', value: 5 }, { text: '後龍鎮', value: 6 }, { text: '通霄鎮', value: 7 }, { text: '苑裡鎮', value: 8 }, { text: '苗栗市', value: 9 }, { text: '造橋鄉', value: 10 }, { text: '公館鄉', value: 11 }, { text: '泰安鄉', value: 12 }, { text: '銅鑼鄉', value: 13 }, { text: '三義鄉', value: 14 }, { text: '西湖鄉', value: 15 }, { text: '卓蘭鎮', value: 16 }, { text: '大湖鄉', value: 17 }], [{ text: '請選擇', value: 0 }, { text: '中區', value: 1 }, { text: '東區', value: 2 }, { text: '南區', value: 3 }, { text: '西區', value: 4 }, { text: '北區', value: 5 }, { text: '北屯區', value: 6 }, { text: '西屯區', value: 7 }, { text: '南屯區', value: 8 }, { text: '太平區', value: 9 }, { text: '大里區', value: 10 }, { text: '霧峰區', value: 11 }, { text: '烏日區', value: 12 }, { text: '豐原區', value: 13 }, { text: '后里區', value: 14 }, { text: '石岡區', value: 15 }, { text: '東勢區', value: 16 }, { text: '和平區', value: 17 }, { text: '新社區', value: 18 }, { text: '潭子區', value: 19 }, { text: '大雅區', value: 20 }, { text: '神岡區', value: 21 }, { text: '大肚區', value: 22 }, { text: '沙鹿區', value: 23 }, { text: '龍井區', value: 24 }, { text: '梧棲區', value: 25 }, { text: '清水區', value: 26 }, { text: '大甲區', value: 27 }, { text: '外埔區', value: 28 }, { text: '大安區', value: 29 }], [{ text: '請選擇', value: 0 }, { text: '彰化市', value: 1 }, { text: '芬園鄉', value: 2 }, { text: '花壇鄉', value: 3 }, { text: '秀水鄉', value: 4 }, { text: '鹿港鎮', value: 5 }, { text: '福興鄉', value: 6 }, { text: '線西鄉', value: 7 }, { text: '和美鎮', value: 8 }, { text: '伸港鄉', value: 9 }, { text: '員林鄉', value: 10 }, { text: '永靖鄉', value: 11 }, { text: '埔心鄉', value: 12 }, { text: '溪湖鎮', value: 13 }, { text: '大村鄉', value: 14 }, { text: '埔鹽鄉', value: 15 }, { text: '田中鎮', value: 16 }, { text: '北斗鎮', value: 17 }, { text: '田尾鄉', value: 18 }, { text: '埤頭鄉', value: 19 }, { text: '溪州鄉', value: 20 }, { text: '竹塘鄉', value: 21 }, { text: '二林鎮', value: 22 }, { text: '大城鄉', value: 23 }, { text: '芳苑鄉', value: 24 }, { text: '二水鄉', value: 25 }, { text: '社頭鄉', value: 26 }], [{ text: '請選擇', value: 0 }, { text: '南投市', value: 1 }, { text: '中寮鄉', value: 2 }, { text: '草屯鎮', value: 3 }, { text: '國姓鄉', value: 4 }, { text: '埔里鎮', value: 5 }, { text: '仁愛鄉', value: 6 }, { text: '名間鄉', value: 7 }, { text: '集集鎮', value: 8 }, { text: '水里鄉', value: 9 }, { text: '魚池鄉', value: 10 }, { text: '信義鄉', value: 11 }, { text: '竹山鎮', value: 12 }, { text: '鹿谷鄉', value: 13 }], [{ text: '請選擇', value: 0 }, { text: '斗南鎮', value: 1 }, { text: '大埤鄉', value: 2 }, { text: '虎尾鎮', value: 3 }, { text: '土庫鎮', value: 4 }, { text: '褒忠鄉', value: 5 }, { text: '東勢鄉', value: 6 }, { text: '台西鄉', value: 7 }, { text: '崙背鄉', value: 8 }, { text: '麥寮鄉', value: 9 }, { text: '斗六市', value: 10 }, { text: '林內鄉', value: 11 }, { text: '古坑鄉', value: 12 }, { text: '莿桐鄉', value: 13 }, { text: '西螺鎮', value: 14 }, { text: '二崙鄉', value: 15 }, { text: '北港鎮', value: 16 }, { text: '水林鄉', value: 17 }, { text: '口湖鄉', value: 18 }, { text: '四湖鄉', value: 19 }, { text: '元長鄉', value: 20 }], [{ text: '請選擇', value: 0 }, { text: '東區', value: 1 }, { text: '西區', value: 2 }], [{ text: '請選擇', value: 0 }, { text: '番路鄉', value: 1 }, { text: '梅山鄉', value: 2 }, { text: '竹崎鄉', value: 3 }, { text: '阿里山鄉', value: 4 }, { text: '中埔鄉', value: 5 }, { text: '大埔鄉', value: 6 }, { text: '水上鄉', value: 7 }, { text: '鹿草鄉', value: 8 }, { text: '太保市', value: 9 }, { text: '朴子市', value: 10 }, { text: '東石鄉', value: 11 }, { text: '六腳鄉', value: 12 }, { text: '新港鄉', value: 13 }, { text: '民雄鄉', value: 14 }, { text: '大林鎮', value: 15 }, { text: '溪口鄉', value: 16 }, { text: '義竹鄉', value: 17 }, { text: '布袋鎮', value: 18 }], [{ text: '請選擇', value: 0 }, { text: '中西區', value: 1 }, { text: '東區', value: 2 }, { text: '南區', value: 3 }, { text: '北區', value: 4 }, { text: '安平區', value: 5 }, { text: '安南區', value: 6 }, { text: '永康區', value: 7 }, { text: '歸仁區', value: 8 }, { text: '新化區', value: 9 }, { text: '左鎮區', value: 10 }, { text: '玉井區', value: 11 }, { text: '楠西區', value: 12 }, { text: '南化區', value: 13 }, { text: '仁德區', value: 14 }, { text: '關廟區', value: 15 }, { text: '龍崎嶇', value: 16 }, { text: '官田區', value: 17 }, { text: '麻豆區', value: 18 }, { text: '佳里區', value: 19 }, { text: '西港區', value: 20 }, { text: '七股區', value: 21 }, { text: '將軍區', value: 22 }, { text: '學甲區', value: 23 }, { text: '北門區', value: 24 }, { text: '新營區', value: 25 }, { text: '後壁區', value: 26 }, { text: '白河區', value: 27 }, { text: '東山區', value: 28 }, { text: '六甲區', value: 29 }, { text: '下營區', value: 30 }, { text: '柳營區', value: 31 }, { text: '鹽水區', value: 32 }, { text: '善化區', value: 33 }, { text: '大內區', value: 34 }, { text: '山上區', value: 35 }, { text: '新市區', value: 36 }, { text: '安定區', value: 37 }], [{ text: '請選擇', value: 0 }, { text: '新興區', value: 1 }, { text: '前金區', value: 2 }, { text: '苓雅區', value: 3 }, { text: '鹽埕區', value: 4 }, { text: '鼓山區', value: 5 }, { text: '旗津區', value: 6 }, { text: '前鎮區', value: 7 }, { text: '三民區', value: 8 }, { text: '楠梓區', value: 9 }, { text: '小港區', value: 10 }, { text: '左營區', value: 11 }, { text: '仁武區', value: 12 }, { text: '大社區', value: 13 }, { text: '東沙群島', value: 14 }, { text: '南沙群島', value: 15 }, { text: '岡山區', value: 16 }, { text: '路竹區', value: 17 }, { text: '阿蓮區', value: 18 }, { text: '田寮區', value: 19 }, { text: '燕巢區', value: 20 }, { text: '橋頭區', value: 21 }, { text: '梓官區', value: 22 }, { text: '彌陀區', value: 23 }, { text: '永安區', value: 24 }, { text: '湖內區', value: 25 }, { text: '鳳山區', value: 26 }, { text: '大寮區', value: 27 }, { text: '林園區', value: 28 }, { text: '六甲區', value: 29 }, { text: '下營區', value: 30 }, { text: '柳營區', value: 31 }, { text: '鹽水區', value: 32 }, { text: '烏林區', value: 33 }, { text: '大樹區', value: 34 }, { text: '旗山區', value: 35 }, { text: '美濃區', value: 36 }, { text: '六龜區', value: 37 }, { text: '內門區', value: 38 }, { text: '杉林區', value: 39 }, { text: '甲仙區', value: 40 }, { text: '桃源區', value: 41 }, { text: '那瑪夏區', value: 42 }, { text: '茂林區', value: 43 }, { text: '茄萣區', value: 44 }, { text: '鳥松區', value: 45 }], [{ text: '請選擇', value: 0 }, { text: '屏東市', value: 1 }, { text: '三地門鄉', value: 2 }, { text: '霧台鄉', value: 3 }, { text: '瑪家鄉', value: 4 }, { text: '九如鄉', value: 5 }, { text: '里港鄉', value: 6 }, { text: '高樹鄉', value: 7 }, { text: '鹽埔鄉', value: 8 }, { text: '長治鄉', value: 9 }, { text: '麟洛鄉', value: 10 }, { text: '竹田鄉', value: 11 }, { text: '內埔鄉', value: 12 }, { text: '萬丹鄉', value: 13 }, { text: '潮州鎮', value: 14 }, { text: '泰武鄉', value: 15 }, { text: '來義鄉', value: 16 }, { text: '萬巒鄉', value: 17 }, { text: '崁頂鄉', value: 18 }, { text: '新埤鄉', value: 16 }, { text: '南州鄉', value: 20 }, { text: '林邊鄉', value: 21 }, { text: '東港鎮', value: 22 }, { text: '琉球鄉', value: 23 }, { text: '佳冬鄉', value: 24 }, { text: '新園鄉', value: 25 }, { text: '枋寮鄉', value: 26 }, { text: '枋山鄉', value: 27 }, { text: '春日鄉', value: 28 }, { text: '獅子鄉', value: 29 }, { text: '車城鄉', value: 30 }, { text: '牡丹鄉', value: 31 }, { text: '恆春鎮', value: 32 }, { text: '滿州鄉', value: 33 }], [{ text: '請選擇', value: 0 }, { text: '台東市', value: 1 }, { text: '綠島鄉', value: 2 }, { text: '蘭嶼鄉', value: 3 }, { text: '延平鄉', value: 4 }, { text: '卑南鄉', value: 5 }, { text: '鹿野鄉', value: 6 }, { text: '關山鎮', value: 7 }, { text: '海端鄉', value: 8 }, { text: '池上鄉', value: 9 }, { text: '東河鄉', value: 10 }, { text: '成功鎮', value: 11 }, { text: '長濱鄉', value: 12 }, { text: '太麻里鄉', value: 13 }, { text: '金峰鄉', value: 14 }, { text: '大武鄉', value: 15 }, { text: '達仁鄉', value: 16 }], [{ text: '請選擇', value: 0 }, { text: '花蓮市', value: 1 }, { text: '新城鄉', value: 2 }, { text: '秀林鄉', value: 3 }, { text: '吉安鄉', value: 4 }, { text: '壽豐鄉', value: 5 }, { text: '鳳林鄉', value: 6 }, { text: '光復鄉', value: 7 }, { text: '豐濱鄉', value: 8 }, { text: '瑞穗鄉', value: 9 }, { text: '萬榮鄉', value: 10 }, { text: '玉里鎮', value: 11 }, { text: '卓溪鄉', value: 12 }, { text: '富里鄉', value: 13 }], [{ text: '請選擇', value: 0 }, { text: '宜蘭市', value: 1 }, { text: '頭城鎮', value: 2 }, { text: '礁溪鄉', value: 3 }, { text: '壯圍鄉', value: 4 }, { text: '員山鄉', value: 5 }, { text: '羅東鎮', value: 6 }, { text: '三星鄉', value: 7 }, { text: '大同鄉', value: 8 }, { text: '五結鄉', value: 9 }, { text: '冬山鄉', value: 10 }, { text: '蘇澳鄉', value: 11 }, { text: '釣魚台', value: 12 }], [{ text: '請選擇', value: 0 }, { text: '馬公市', value: 1 }, { text: '西嶼鄉', value: 2 }, { text: '望安鄉', value: 3 }, { text: '七美鄉', value: 4 }, { text: '白沙鄉', value: 5 }, { text: '湖西鄉', value: 6 }], [{ text: '請選擇', value: 0 }, { text: '金沙鎮', value: 1 }, { text: '金湖鎮', value: 2 }, { text: '金寧鄉', value: 3 }, { text: '金城鎮', value: 4 }, { text: '烈嶼鄉', value: 5 }, { text: '烏坵鄉', value: 6 }], [{ text: '請選擇', value: 0 }, { text: '南竿鄉', value: 1 }, { text: '北竿鄉', value: 2 }, { text: '莒光鄉', value: 3 }, { text: '東引鄉', value: 4 }]]
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["a" /* SET_TOKEN */], function (state, token) {
  state.token = token;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["b" /* LOGOUT */], function () {
  localStorage.removeItem('cart');
  localStorage.removeItem('userId');
  localStorage.removeItem('shareid');
  localStorage.removeItem('userName');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userAddress');
  localStorage.removeItem('userCounty');
  localStorage.removeItem('userDistrict');
  localStorage.removeItem('userCash');
  localStorage.removeItem('userValid');
  localStorage.removeItem('userPhone');
  localStorage.removeItem('userStock');
  localStorage.removeItem('token');
  localStorage.removeItem('firstbuy');
  state.authenticated = false;
  state.userId = '';
  state.userName = '';
  state.token = '';
  state.userValid = '';
  state.firstbuy = 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["c" /* CLEAR_FIRST_BUY */], function () {
  state.firstbuy = 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["d" /* UPDATEUSER */], function (state, creds) {
  var data = creds.data;
  if (localStorage) {
    state.userName = data.userName;
    state.userPhone = data.userPhone;
    localStorage.setItem('userName', data.userName);
    localStorage.setItem('userPhone', data.userPhone);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["e" /* LOGIN */], function (state, creds) {
  state.authenticated = true;
  var data = creds.data;
  if (localStorage) {
    state.userId = data.userId;
    state.userName = data.userName;
    state.token = data.token;
    state.userEmail = data.userEmail;
    state.userPhone = data.userPhone;
    state.userCounty = data.userCounty;
    state.userDistrict = data.userDistrict;
    state.userAddress = data.userAddress;
    state.userCash = data.userCash;
    state.volunteer_quota = data.volunteer_quota;
    state.userValid = data.userValid;
    state.userStock = data.userStock;
    state.firstbuy = parseInt(data.firstbuy);
    localStorage.setItem('userId', data.userId);
    localStorage.setItem('shareid', data.userId);
    localStorage.setItem('userName', data.userName);
    localStorage.setItem('token', data.token);
    localStorage.setItem('userEmail', data.userEmail);
    localStorage.setItem('userPhone', data.userPhone);
    localStorage.setItem('userCounty', data.userCounty);
    localStorage.setItem('userDistrict', data.userDistrict);
    localStorage.setItem('userAddress', data.userAddress);
    localStorage.setItem('userCash', data.userCash);
    localStorage.setItem('volunteer_quota', data.volunteer_quota);
    localStorage.setItem('userValid', data.userValid);
    localStorage.setItem('userStock', data.userStock);
    localStorage.setItem('firstbuy', data.firstbuy);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["f" /* SET_NEWS */], function (state, data) {
  state.news = data;
  localStorage.setItem('news', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["g" /* SET_COMPANIES */], function (state, data) {
  state.companies = data;
  localStorage.setItem('companies', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["h" /* SET_SLIDE */], function (state, data) {
  state.slide = data;
  localStorage.setItem('slide', data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'check', function check() {
  var jwt = localStorage.getItem('token');
  if (jwt) {
    state.authenticated = true;
  } else {
    state.authenticated = false;
  }
}), _mutations);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations_types_js__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = ({
  SET_PRODUCTS: function SET_PRODUCTS(_ref, products) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["a" /* SET_PRODUCTS */], products);
  },
  SET_POPULAR: function SET_POPULAR(_ref2, products) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["b" /* SET_POPULAR */], products);
  },
  SET_ADDON: function SET_ADDON(_ref3, addon) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["c" /* SET_ADDON */], addon);
  },
  SET_SHARE_ID: function SET_SHARE_ID(_ref4, shareid) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["d" /* SET_SHARE_ID */], shareid);
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getProducts: function getProducts(state) {
    return state.products;
  },
  getPopular: function getPopular(state) {
    return state.popular;
  },
  getAddon: function getAddon(state) {
    return state.addon;
  },
  getShareid: function getShareid(state) {
    return state.shareid;
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js__ = __webpack_require__(164);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["a" /* state */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["b" /* mutations */],
  strict: true
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__ = __webpack_require__(19);



var _mutations;



var state = {
  products: [],
  popular: [],
  addon: [],
  shareid: 0
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["a" /* SET_PRODUCTS */], function (state, data) {
  state.products = data;
  window.localStorage.setItem('products', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["b" /* SET_POPULAR */], function (state, data) {
  state.popular = data;

  window.localStorage.setItem('popular', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["c" /* SET_ADDON */], function (state, data) {
  state.addon = data;
  window.localStorage.setItem('addon', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["d" /* SET_SHARE_ID */], function (state, shareid) {
  state.shareid = shareid;
  window.localStorage.setItem('shareid', shareid);
}), _mutations);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__);



/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        text: { type: String, required: true },
        size: { type: Number, required: false, default: 256 },
        color: { type: String, required: false, default: '#000' },
        bgColor: { type: String, required: false, default: '#FFF' },
        errorLevel: {
            type: String,
            validator: function validator(value) {
                return value === 'L' || value === 'M' || value === 'Q' || value === 'H';
            },
            required: false,
            default: 'H'
        }
    },

    watch: {
        text: function text() {
            this.clear();
            this.makeCode(this.text);
        }
    },

    data: function data() {
        return {
            qrCode: {}
        };
    },
    mounted: function mounted() {
        this.qrCode = new __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a(this.$el, {
            text: this.text,
            width: this.size,
            height: this.size,
            colorDark: this.color,
            colorLight: this.bgColor,
            correctLevel: __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a.CorrectLevel[this.errorLevel]
        });
    },


    methods: {
        clear: function clear() {
            this.qrCode.clear();
        },
        makeCode: function makeCode(text) {
            this.qrCode.makeCode(text);
        }
    }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'About',
  metaInfo: {
    title: '愛幫您-關於我們',
    meta: [{
      name: '愛幫您-關於我們',
      content: '我們正在推廣世界銀行的概念，讓貧窮消失在世界上'
    }],
    link: [{
      rel: 'about',
      href: 'https://www.i80.com.tw/about'
    }]
  },
  data: function data() {
    return {
      rowData: {}
    };
  },

  mounted: function mounted() {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews']))
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      email: '',
      password: '',
      apiurl: 'https://affiliate.i80.com.tw/',
      showCart: false,
      verified: false
    };
  },

  mounted: function mounted() {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['LOGIN', 'LOGOUT', 'DELETE_TO_CART']), {
    logout: function logout() {
      var _this = this;

      this.$store.dispatch('LOGOUT').then(function () {
        _this.$router.push('/');
      });
    },
    login: function login() {
      var email = this.email;
      var password = this.password;
      this.$http.post(this.apiurl + 'api/member_login', {
        email: email,
        password: password
      }).then(function (res) {
        var _this2 = this;

        var status = res.body.status;
        if (status === 200) {
          var data = {
            userId: res.body.id,
            userName: res.body.name,
            userEmail: res.body.email,
            userPhone: res.body.phone,
            userAddress: res.body.address,
            userCash: res.body.cash,
            userCounty: res.body.county,
            userDistrict: res.body.district,
            firstbuy: parseInt(res.body.firstbuy),
            userValid: res.body.valid,
            userStock: res.body.stock,
            token: res.body.token,
            source_from: 'web'
          };

          this.$store.dispatch('LOGIN', data).then(function () {
            _this2.$router.go('/member');
          });
        } else {
          window.alert('您輸入的帳號或密碼錯誤，請重新輸入。');
        }
      }, function () {
        console.log('failed');
      });
    },
    showCartList: function showCartList() {
      if (this.showCart === false) {
        this.showCart = true;
      } else {
        this.showCart = false;
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    userName: 'getUserName',
    news: 'getNews',
    items: 'getCart',
    userID: 'getUserID'
  }))
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Apply',
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/api',
      com_name: '',
      com_phone: '',
      contact_name: '',
      email: '',
      password: '',
      com_number: '',
      address: '',
      contact_phone: '',
      com_site: '',
      latest: '',
      productCategory: '',
      introduction: '',
      reliablemanid: 0,
      pricing: 10000,
      flag: false,
      pricingList: [{ text: '10000', value: 10000 }, { text: '20000', value: 20000 }, { text: '30000', value: 30000 }, { text: '40000', value: 40000 }, { text: '50000', value: 50000 }]
    };
  },

  mounted: function mounted() {
    this.$http.get(this.apiurl + '/latestAffiliate').then(function (res) {
      this.latest = res.body.data;
    }, function () {
      console.log('failed');
    });
  },
  methods: {
    apply: function apply() {
      var str = '';
      if (!this.com_name) {
        str += '請填寫廠商名稱。\n';
      } else if (!this.com_phone) {
        str += '請先填寫聯絡電話。\n';
      } else if (this.contact_name === '') {
        str += '請先填寫聯絡人姓名。\n';
      } else if (this.email === '') {
        str += '請先填寫電子信箱。\n';
      } else if (this.password === '') {
        str += '請先填密碼。\n';
      } else if (this.pricing === '') {
        str += '請選擇上架費金額。\n';
      }

      var rulename = new RegExp('^[\u4E00-\u9FA5_a-zA-Z]+$');
      if (!rulename.test(this.contact_name)) {
        str += '您的姓名只能輸入中文或英文。';
      }

      var rulphone = new RegExp('^[09]{2}[0-9]{8}$');
      if (!rulphone.test(this.contact_phone)) {
        str += '您輸入聯絡人手機不正確。';
      }
      var ruleEmail = new RegExp(/^[^\s]+@[^\s]+\.[^\s]+$/);
      if (!ruleEmail.test(this.email)) {
        str += '您輸入的Email不正確。';
      }
      if (str === '') {
        this.flag = true;
        this.$http.post('https://affiliate.i80.com.tw/api/addAffiliate', {
          com_email: this.email,
          com_name: this.com_name,
          c_website: this.com_site,
          com_number: this.com_number,
          com_reliableman: this.contact_name,
          com_phone: this.com_phone,
          com_contact_phone: this.contact_phone,
          com_address: this.address,
          introduction: this.introduction,
          productCategory: this.productCategory,
          password: this.password,
          pricing: this.pricing,
          reliablemanid: this.reliablemanid
        }).then(function (res) {
          var status = res.body.status;
          if (status === 200) {
            window.alert('申請成功，我們將盡快為您處理。');
          } else {
            window.alert('申請失敗，請重新申請。');
          }
        }, function () {
          console.log('failed');
        });
      } else {
        window.alert(str);
      }
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Contact',
  metaInfo: {
    title: '愛幫您-聯絡我們',
    meta: [{
      name: '愛幫您-聯絡我們',
      content: '歡迎與我們聯絡合作方案'
    }],
    link: [{
      rel: 'contact',
      href: 'https://www.i80.com.tw/contact'
    }]
  },
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      name: '',
      phone: '',
      email: '',
      content: ''
    };
  },

  mounted: function mounted() {
    this.$http.get(this.apiurl + '/latestAffiliate').then(function (res) {
      this.latest = res.body.data;
    }, function () {
      console.log('failed');
    });
  },
  methods: {
    contact: function contact() {
      var str = '';
      if (this.name === '') {
        str += '請填寫姓名。\n';
      } else if (this.email === '' || typeof this.email === 'undefined') {
        str += '請輸入您的Email\n';
      } else if (this.content === '' || typeof this.content === 'undefined') {
        str += '請輸入您的問題。\n';
      } else if (this.phone === '' || typeof this.phone === 'undefined') {
        str += '請輸入您的聯絡電話\n';
      }
      if (str === '') {
        this.$http.post(this.apiurl + 'api/messages', {
          email: this.email,
          name: this.name,
          phone: this.phone,
          content: this.content
        }).then(function (res) {
          var status = res.status;
          if (status === 200) {
            window.alert('留言成功，我們將盡快回覆您。');
          } else {
            window.alert('留言失敗');
          }
        }, function () {
          console.log('failed');
        });
      } else {
        window.alert(str);
      }
    }
  },
  computed: {}
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Faq',
  data: function data() {
    return {
      com_name: ''
    };
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Forgotpass',
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      email: '',
      account: ''
    };
  },

  mounted: function mounted() {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    findPassword: function findPassword() {
      var str = '';
      if (this.email === '') {
        str += '請輸入您的Email，我們將預設為您的『大寫身份證字號』。\n';
      }
      if (str === '') {
        this.$http.post(this.apiurl + 'api/getPassword', {
          email: this.email
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (res) {
          var data = res.body.data;
          var status = data.status;
          if (status === 200) {
            window.alert('查詢成功，您的密碼已預設為身份證字號。');
          } else {
            window.alert('查詢失敗');
          }
        }, function () {
          console.log('failed');
        });
      } else {
        window.alert(str);
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews']))
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FreeTrial',
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/api',
      com_name: '',
      com_phone: '',
      contact_name: '',
      email: '',
      password: '',
      county: this.$store.getters.getCounty,
      district: [],
      countyval: '',
      districtval: '',
      address: '',
      com_number: '',
      contact_phone: '',
      com_site: '',
      latest: '',
      productCategory: '',
      introduction: '',
      reliablemanid: 0,
      pricing: 10000,
      flag: false,
      i_read_agreement: false
    };
  },

  mounted: function mounted() {
    this.$http.get(this.apiurl + '/latestAffiliate').then(function (res) {
      this.latest = res.body.data;
    }, function () {
      console.log('failed');
    });
  },
  methods: {
    apply: function apply() {
      var str = '';
      if (!this.i_read_agreement) {
        str += '請先勾選 「我已詳細閱讀聯盟合約內容」\n';
      } else if (!this.com_name) {
        str += '請填寫廠商名稱。\n';
      } else if (!this.com_phone) {
        str += '請先填寫聯絡電話。\n';
      } else if (this.contact_name === '') {
        str += '請先填寫聯絡人姓名。\n';
      } else if (this.email === '') {
        str += '請先填寫電子信箱。\n';
      } else if (this.password === '') {
        str += '請先填密碼。\n';
      } else if (this.pricing === '') {
        str += '請選擇上架費金額。\n';
      }

      if (this.countyval === '' || this.districtval === '') {
        str += '請選擇縣市及區域，(若持續出現，請換另一個瀏覽器嘗試)\n';
      }
      if (this.address === '') {
        str += '請填寫地址\n';
      }

      var rulename = new RegExp('^[\u4E00-\u9FA5_a-zA-Z]+$');
      if (!rulename.test(this.contact_name)) {
        str += '您的姓名只能輸入中文或英文。\n';
      }

      var rulphone = new RegExp('^[09]{2}[0-9]{8}$');
      if (!rulphone.test(this.contact_phone)) {
        str += '您輸入聯絡人手機不正確。\n';
      }
      var ruleEmail = new RegExp(/^[^\s]+@[^\s]+\.[^\s]+$/);
      if (!ruleEmail.test(this.email)) {
        str += '您輸入的Email不正確。';
      }
      if (str === '') {
        this.flag = true;
        this.$http.post('https://affiliate.i80.com.tw/api/addAffiliate', {
          com_email: this.email,
          com_name: this.com_name,
          c_website: this.com_site,
          com_number: '',
          com_reliableman: this.contact_name,
          com_phone: this.com_phone,
          com_contact_phone: this.contact_phone,
          county: this.countyval,
          district: this.districtval,
          com_address: this.address,
          introduction: '',
          productCategory: this.productCategory,
          password: this.password,
          pricing: this.pricing,
          reliablemanid: this.reliablemanid
        }).then(function (res) {
          var status = res.body.status;
          if (status === 200) {
            window.alert('申請成功，我們將盡快為您處理。');
          } else {
            window.alert('申請失敗，請重新申請。');
          }
        }, function () {
          console.log('failed');
        });
      } else {
        window.alert(str);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getCounty'])),
  watch: {
    countyval: {
      handler: function handler(val, oldVal) {
        var key = parseInt(val) - 1;
        var district = this.$store.getters.getDistrict;
        this.district = district[key];
      }
    }
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GoodPrice',
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      rowData: {},
      orderNumber: 1,
      id: '',
      items: this.$store.getters.getCart,
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    };
  },

  mounted: function mounted() {
    var id = this.$route.params.id;
    this.id = 'https://www.i80.com.tw/product/' + id;
    var getProducts = this.$store.getters.getProducts;
    var data = [];
    getProducts.forEach(function (val, idx) {
      if (parseInt(val.id) === parseInt(id)) {
        data.push(val);
      }
    });

    if (data.length < 1) {
      this.$http.get(this.apiurl + 'api/getProductID/' + id).then(function (res) {
        this.rowData = res.body.data[0];
      }, function () {});
    } else {
      this.rowData = data[0];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['SET_PRODUCTS']), {
    addToCart: function addToCart(row) {
      var cart = this.items;
      if (cart.length > 0) {
        if (cart[0].fid !== row.fid) {
          window.alert('平台採單店結帳，請先進行結帳再購買其他店家商品謝謝');
        }
      }
      this.$store.dispatch('ADD_TO_CART', row);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    popular: 'getPopular'
  })),
  watch: {
    orderNumber: {
      handler: function handler(val, oldVal) {
        this.rowData.quantity = val;
      }
    }
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






var homeSlide = [{
  id: 1,
  image: '/static/images/index/banner2.jpg'
}, {
  id: 2,
  image: '/static/images/index/banner3.jpg'
}];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Main',
  data: function data() {
    return {
      apiurl: this.$store.getters.getAPI,
      homeSlide: homeSlide
    };
  },

  mounted: function mounted() {
    var companies = window.localStorage.getItem('companies');
    var news = window.localStorage.getItem('news');
    this.companies = JSON.parse(companies);
    this.news = JSON.parse(news);

    var shareid = this.$route.params.shareid;
    if (shareid) {
      this.$store.dispatch('SET_SHARE_ID', shareid);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['SET_NEWS'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    news: 'getNews',
    companies: 'getCompanies'
  })),
  filters: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('DD');
    },
    formatMonth: function formatMonth(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MM');
    },
    truncate: function truncate(string, value) {
      var str = string.replace(/<\/?[^>]+(>|$)/g, '');
      return str.substring(0, value) + '...';
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Active',
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/'
    };
  },

  mounted: function mounted() {
    var data = {
      verifycode: this.$route.params.verifycode,
      id: this.$route.params.id
    };
    this.active(data);
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    active: function active(data) {
      var str = '';
      if (data.verifycode === '') {
        str += '驗證代碼錯誤\n';
      }
      if (str === '') {
        this.$http.post(this.apiurl + 'api/avticeMember', {
          activecode: data.verifycode,
          userid: data.id
        }).then(function (res) {
          var data = res.body.data;
          if (data.status === 200) {
            window.alert('會員驗證啟動成功。');
          } else {
            window.alert('會員驗證失敗。');
          }
        }, function () {
          console.log('failed');
        });
      } else {
        window.alert(str);
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews']))
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Agreement',
  data: function data() {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      agreements: []
    };
  },

  mounted: function mounted() {
    this.$http.get(this.memberurl + '/agreement', { params: { token: this.token } }).then(function (res) {
      var data = res.body.lists;
      this.agreements = data;
    }, function () {
      console.log('failed');
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    agreement_signed: function agreement_signed(id, title) {
      if (confirm('確認同意並簽署「' + title + '」合約嗎？')) {
        this.$http.post(this.memberurl + '/agreement_signed', {
          id: this.userID,
          agreement_id: id,
          token: this.token
        }).then(function (res) {
          var status = res.body.data;
          if (status === 200) {
            window.alert('簽署成功');
          } else {
            window.alert('簽署失敗');
          }
        }, function () {
          console.log('failed');
        });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews']))
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a
  },
  name: 'Bonus',
  data: function data() {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      bonus: [],
      choosemonth: ''
    };
  },

  mounted: function mounted() {
    this.getBonus();
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    getBonus: function getBonus() {
      var date = new Date(this.choosemonth);

      var queryDate = date.getFullYear();

      this.$http.get(this.memberurl + '/member_bonus', { params: { token: this.token, month: queryDate } }).then(function (res) {
        var data = res.body.data;
        if (data.bonus.length > 0) {
          this.bonus = data.bonus;
        } else {
          window.alert('該月份尚未有回饋金。');
        }
      }, function () {
        console.log('failed');
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews'])),
  filters: {
    formatMonth: function formatMonth(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('YYYY-MM');
    }
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['show'],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a,
    modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"]
  },
  name: 'Consume',
  data: function data() {
    return {
      fadeModal: false,
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      consume: [],
      choosemonth: '',
      detail: '',
      searchFlag: false
    };
  },

  mounted: function mounted() {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    getConsume: function getConsume() {
      var date = new Date(this.choosemonth);
      var queryDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2);

      this.searchFlag = true;
      var token = this.$store.getters.getToken;
      this.$http.get(this.memberurl + '/member_consume', { params: { token: token, month: queryDate } }).then(function (res) {
        this.searchFlag = false;
        var data = res.body.data;
        if (data.length > 0) {
          this.consume = data;
        } else {
          window.alert('您該月份未有消費紀錄');
        }
      }, function () {
        console.log('failed');
      });
    },
    getDetail: function getDetail(id) {
      this.fadeModal = true;
      var token = this.$store.getters.getToken;
      this.$http.get(this.memberurl + '/member_consume_detail', { params: { token: token, id: id } }).then(function (res) {
        var data = res.body.data;
        if (data.length > 0) {
          this.detail = data;
        } else {
          window.alert('查詢失敗');
        }
      }, function () {
        console.log('failed');
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews']))
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Member',
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    token: 'getToken'
  }))
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['show'],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a,
    modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"]
  },
  name: 'Order',
  data: function data() {
    return {
      fadeModal: false,
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: '',
      consume: [],
      choosemonth: '',
      detail: '',
      apiurl: 'https://affiliate.i80.com.tw/',
      searchFlag: false
    };
  },

  mounted: function mounted() {
    this.token = this.$store.getters.getToken;
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    getConsume: function getConsume() {
      var date = new Date(this.choosemonth);
      var queryDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2);
      this.searchFlag = true;
      this.$http.get(this.memberurl + '/member_consume', { params: { token: this.token, month: queryDate } }).then(function (res) {
        this.searchFlag = false;
        var data = res.body.data;
        if (data.length > 0) {
          this.consume = data;
        } else {
          window.alert('您該月份未有消費紀錄');
        }
      }, function () {
        console.log('failed');
      });
    },
    getDetail: function getDetail(id) {
      this.fadeModal = true;
      this.$http.get(this.memberurl + '/member_consume_detail', { params: { token: this.token, id: id } }).then(function (res) {
        var data = res.body.data;
        if (data.length > 0) {
          this.detail = data;
        } else {
          window.alert('查詢失敗');
        }
      }, function () {
        console.log('failed');
      });
    },
    cancel: function cancel(orderID) {
      this.$http.post(this.apiurl + 'api/cancelOrder', {
        orderid: orderID,
        id: this.userID,
        token: this.token
      }).then(function (res) {
        var data = res.body.data;
        if (data.comid !== '') {
          window.alert('取消單據成功。');
          this.getConsume();
        } else {
          window.alert('取消單據失敗。');
        }
      }, function () {
        console.log('failed');
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews']))
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a
  },
  name: 'Performance',
  data: function data() {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      performance: [],
      choosemonth: '',
      person_bonus: 0,
      totalBonus: 0,
      personal: 0,
      group: 0,
      Minimum: 0,
      searchFlag: false
    };
  },

  mounted: function mounted() {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    getPerformance: function getPerformance() {
      var date = new Date(this.choosemonth);
      var queryDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2);
      this.searchFlag = true;
      this.$http.get(this.memberurl + '/member_performance', { params: { token: this.token, month: queryDate } }).then(function (res) {
        this.searchFlag = false;
        var data = res.body.data;
        var companyAmount = data[0].companyAmount;
        this.performance = data;
        this.totalBonus = data[0].totalBonus;
        this.Minimum = parseInt(data[0].point * 2) + companyAmount;
        this.personal = data[0].personal;
        this.person_bonus = data[0].person_bonus;
        this.group = data[0].group;
      }, function () {
        console.log('failed');
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews'])),
  filters: {
    formatMonth: function formatMonth(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM');
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Personal',
  data: function data() {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: '',
      apiurl: 'https://affiliate.i80.com.tw/',
      county: this.$store.getters.getCounty,
      district: this.$store.getters.getDistrict,
      phone: '',
      name: '',
      password: '',
      password2: '',
      personal: '',
      email: '',
      personalForm: false
    };
  },

  mounted: function mounted() {
    this.token = this.$store.getters.getToken;
    this.phone = this.$store.getters.getUserPhone;
    this.name = this.$store.getters.getUserName;
    this.email = this.$store.getters.getEmail;


    this.$http.get(this.memberurl + '/member_personal_info', {
      params: {
        token: this.token
      }
    }).then(function (res) {
      var data = res.body.data;
      this.personal = data;
    }, function () {
      console.log('failed');
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    oepnForm: function oepnForm() {
      this.personalForm = true;
    },
    editPersonal: function editPersonal() {
      var name = this.name;
      var phone = this.phone;
      var email = this.email;
      var password = this.password;
      var password2 = this.password2;
      if (password !== password2 || password === '' && password2 !== '' || password !== '' && password2 === '') {
        window.alert('兩次密碼輸入不同，請確認後再送出');
      } else if (name === '' || phone === '') {
        window.alert('帳號與手機不得為空。');
      } else {
        this.$http.post(this.apiurl + 'api/updateUser', {
          name: name,
          id: this.userID,
          phone: phone,
          password: password,
          email: email,
          token: this.token
        }).then(function (res) {
          var data = res.body.data;
          if (data.status === 200) {
            var setData = {
              userName: data.name,
              userPhone: data.phone
            };
            this.$store.dispatch('UPDATEUSER', setData);
            window.alert('更新成功');
            this.personalForm = false;
          } else {
            window.alert('更新失敗');
          }
        }, function () {
          console.log('failed');
        });
      }
    },
    cancel: function cancel() {
      this.personalForm = false;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getCounty', 'getDistrict', 'getUserPhone', 'getUserName']))
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['show'],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a
  },
  name: 'Redeen',
  data: function data() {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      redeen: [],
      choosemonth: '',
      detail: '',
      searchFlag: false
    };
  },

  mounted: function mounted() {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    getConsume: function getConsume() {
      var date = new Date(this.choosemonth);
      var queryDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2);

      this.searchFlag = true;
      var token = this.$store.getters.getToken;
      this.$http.get(this.memberurl + '/member_redeens', { params: { token: token, month: queryDate } }).then(function (res) {
        this.searchFlag = false;
        var data = res.body.redeen;
        if (data.length > 0) {
          this.redeen = data;
        } else {
          window.alert('您該月份未有抵用券');
        }
      }, function () {
        console.log('failed');
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews']))
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_component__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_qrcode_component__);






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('qr-code', __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_component___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Share',
  data: function data() {
    return {
      userID: this.$store.getters.getUserID,
      qr: 'https://www.i80.com.tw/Register/' + localStorage.getItem('userId')
    };
  },

  mounted: function mounted() {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['GET_NEWS'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getUserID']))
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Team',
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a
  },
  data: function data() {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      team: [],
      originData: [],
      choosemonth: '',
      membername: ''
    };
  },

  mounted: function mounted() {
    var id = this.userID;
    this.$http.get(this.memberurl + '/member_team', { params: { token: this.token, id: id } }).then(function (res) {
      var data = res.body.data;

      this.team = data.org;
      this.originData = data.org;
    }, function () {
      console.log('failed');
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    doFilter: function doFilter() {},
    reset: function reset() {
      this.membername = '';
      this.choosemonth = '';
    }
  }),
  watch: {
    membername: {
      handler: function handler(val, oldVal) {
        this.team = this.originData.filter(function (value) {
          return value.org_name.indexOf(val) >= 0;
        });
      }
    },
    choosemonth: {
      handler: function handler(val, oldVal) {
        this.team = this.originData.filter(function (value) {
          var date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(value.created_at).format('YYYY-MM-DD');
          var inputDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(val).format('YYYY-MM-DD');
          return date === inputDate;
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews']))
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Training',
  data: function data() {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      training: []
    };
  },

  mounted: function mounted() {
    this.$http.get(this.memberurl + '/training', { params: { token: this.token } }).then(function (res) {
      var data = res.body.data;
      this.training = data;
    }, function () {
      console.log('failed');
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews']))
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Privacy',
  data: function data() {
    return {
      rowData: {}
    };
  },

  mounted: function mounted() {},
  methods: {}
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'News',
  data: function data() {
    return {
      news: {}
    };
  },
  created: function created() {},

  mounted: function mounted() {
    var news = window.localStorage.getItem('news');
    this.news = JSON.parse(news);
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['GET_NEWS'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getNews'])),
  filters: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('DD');
    },
    formatMonth: function formatMonth(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MM');
    },
    truncate: function truncate(string, value) {
      var str = string.replace(/<\/?[^>]+(>|$)/g, '');
      return str.substring(0, value) + '...';
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'News',
  data: function data() {
    return {
      news: this.$store.getters.getNews,
      apiurl: this.$store.getters.getAPI,
      rowData: {}
    };
  },

  mounted: function mounted() {
    var id = this.$route.params.id;

    this.rowData = this.news[id];
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getNews']))
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Operators',
  data: function data() {
    return {
      rowData: {}
    };
  },

  mounted: function mounted() {}
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Privacy',
  data: function data() {
    return {
      rowData: {}
    };
  },

  mounted: function mounted() {},
  methods: {}
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Product',
  data: function data() {
    return {
      productList: '',
      promoteList: [],
      keyword: '',
      priceFlag: true,
      catalog: [{ text: '日常用品', value: 1 }, { text: '大眾商品', value: 2 }, { text: '休閒旅遊', value: 3 }, { text: '影音藝文', value: 4 }, { text: '美容美妝', value: 5 }, { text: '3c商品', value: 6 }, { text: '生活服務', value: 7 }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    userID: 'getUserID'
  })),
  mounted: function mounted() {
    var products = localStorage.getItem('products');
    products = JSON.parse(products);
    this.productList = products.sort(function (a, b) {
      return a.sorting - b.sorting;
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['ADD_TO_CART']), {
    addToCart: function addToCart(row) {
      this.$store.dispatch('ADD_TO_CART', row);
    },
    ProductSearch: function ProductSearch() {
      var keyword = this.keyword;
      if (keyword !== '') {
        this.productList = this.productList.filter(function (value) {
          return value.name.indexOf(keyword) >= 0;
        });
      } else {
        this.productList = this.$store.getters.getProducts;
      }
    },
    even: function even(arr) {
      return arr.sort(function (a, b) {
        return a.sorting - b.sorting;
      });
    }
  })
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductView',
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      rowData: {},
      company: {},
      orderNumber: 1,
      id: '',
      shareLink: '',
      items: this.$store.getters.getCart,
      firstbuy: this.$store.getters.getFirstbuy,
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    };
  },

  mounted: function mounted() {},
  created: function created() {
    var id = this.$route.params.id;
    var shareid = this.$route.params.shareid;
    if (shareid > 0) {
      this.$store.dispatch('SET_SHARE_ID', shareid);
      localStorage.setItem('shareid', shareid);
    } else {
      shareid = localStorage.getItem('userId');
    }
    this.id = id;
    this.shareLink = 'https://www.i80.com.tw/product/' + id + '/' + shareid;

    this.$http.get(this.apiurl + 'api/getProductID/' + id).then(function (res) {
      var row = res.body.data[0];
      this.rowData = row;

      var companies = JSON.parse(localStorage.getItem('companies'));
      this.company = companies.find(function (item, index, array) {
        return item.m_factoryID === row.fid;
      });
    }, function () {
      console.log('loading products is failed.');
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['SET_PRODUCTS', 'SET_SHARE_ID']), {
    addToCart: function addToCart(row) {
      var cart = this.items;
      if (cart.length > 0) {
        if (cart[0].fid !== row.fid) {
          window.alert('平台採單店結帳，請先進行結帳再購買其他店家商品謝謝');
          return false;
        }
      }
      row.maximum = 20;
      this.$store.dispatch('SAVE_ACTIVITY_ITEM', row.id);
      this.$store.dispatch('ADD_TO_CART', row);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    popular: 'getPopular'
  })),
  watch: {
    orderNumber: {
      handler: function handler(val, oldVal) {
        this.rowData.quantity = val;
      }
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Register',
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      rowData: {},
      agreement: true,
      member_policy: true,
      account: '',
      password: '',
      doublepassword: '',
      name: '',
      phone: '',
      parentid: '',
      identify: '',
      countyval: '',
      districtval: '',
      county: this.$store.getters.getCounty,
      district: [],
      address: '',
      validated: 0,
      flag: false,
      loading: false,
      displaypwd: false,
      passwordType: true
    };
  },

  components: {
    PulseLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader_vue___default.a
  },
  mounted: function mounted() {
    var parentID = this.$route.params.id;
    if (parentID) {
      this.parentid = parentID;
      localStorage.setItem('shareid', parentID);
    } else {
      this.parentid = localStorage.getItem('shareid');
    }
    if (this.parentid) {
      this.validated = 1;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['getShareid']), {
    onChange: function onChange() {
      this.displaypwd = true;
      if (this.passwordType === true) {
        this.passwordType = false;
      } else {
        this.passwordType = true;
      }
    },
    register: function register() {
      try {
        var email = this.account.toLowerCase();
        var str = '';
        if (this.name === '') {
          str += '請填寫個人姓名。\n';
        } else if (email === '' || !email) {
          str += '請輸入您的 Email\n';
        } else if (this.password === '' || !this.password) {
          str += '請輸入您的密碼\n';
        } else if (this.phone === '' || !this.phone) {
          str += '請輸入您的聯絡電話\n';
        } else if (this.identify === '' || !this.identify) {
          str += '請輸入您的身分證字號\n';
        } else if (!this.agreement) {
          str += '請勾選同意隱私權政策。\n';
        } else if (!this.member_policy) {
          str += '請勾選同意會員條款。\n';
        }

        var rulename = new RegExp('^[\u4E00-\u9FA5_a-zA-Z]+$');
        if (!rulename.test(this.name)) {
          str += '您的姓名只能輸入中文或英文。\n';
        }

        var ruleemail = new RegExp('^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$');
        if (!ruleemail.test(email)) {
          str += '您輸入 Email 格式不正確。\n';
        }
        var rule = new RegExp('^[A-Za-z]{1,2}[1-2]{1}[0-9]{7,8}$');
        if (!rule.test(this.identify)) {
          str += '您輸入身分證字號格式不正確。\n';
        }

        var rulep = new RegExp('^[09]{2}[0-9]{8}$');
        if (!rulep.test(this.phone)) {
          str += '您輸入的手機格式不正確。\n';
        }

        var password_rule = new RegExp('^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,20}$');
        if (!password_rule.test(this.password)) {
          str += '密碼格式不符，至少超過 6 碼，且包含數字及大小寫英文\n';
        }
        if (this.password !== this.doublepassword) {
          str += '您兩次輸入的密碼不正確。\n';
        }

        if (str === '' && this.flag === false) {
          this.loading = true;
          this.flag = true;
          this.$http.post(this.apiurl + 'api/register', {
            email: email,
            org_account: this.account,
            password: this.password,
            org_cellphone: this.phone,
            parent_id: this.parentid,
            org_name: this.name,
            org_identify: this.identify.toUpperCase(),
            org_country: this.countyval,
            org_town: this.districtval,
            org_address: this.address,
            user_agent: navigator.userAgent,
            org_from: 'website'
          }).then(function (res) {
            this.loading = false;
            var data = res.body.data;
            var id = data.id;
            if (data.status !== 503) {
              window.alert('註冊成功，您的編號為:' + id);
              this.$router.go('/');
            } else {
              window.alert('註冊失敗，此組『信箱』或『身份證』，已註冊過帳號。');
              this.flag = false;
            }
          }, function () {
            console.log('failed');
          });
        } else {
          window.alert(str);
        }
      } catch (error) {
        window.alert(error);
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getCounty'])),
  watch: {
    countyval: {
      handler: function handler(val, oldVal) {
        var key = parseInt(val) - 1;
        var district = this.$store.getters.getDistrict;
        this.district = district[key];
      }
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResetPassword',
  data: function data() {
    return {
      password: ''
    };
  },

  mounted: function mounted() {
    var token = this.$route.params.token;
    this.$http.post(this.apiurl + 'api/resetpassword', {
      token: token
    }).then(function (res) {
      var status = res.body.status;
      if (status === 200) {} else {
        window.alert('您輸入的帳號或密碼錯誤，請重新輸入。');
      }
    }, function () {
      console.log('failed');
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['getCompanies'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getAPI']))
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchProduct',
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      originProduct: Object,
      products: [],
      rowData: {},
      userID: this.$store.getters.getUserID,
      paginate: ['products'],
      keyword: '',
      category: [],
      categorySelected: 0,
      flag: false
    };
  },

  created: function created() {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getCompanies'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['ADD_TO_CART']), {
    SearchProduct: function SearchProduct() {
      var vm = this;
      var keyword = this.keyword;
      if (keyword !== '' && keyword.length > 1) {
        vm.products = [];
        this.$http.post(this.apiurl + 'api/product/search', {
          keyword: keyword
        }).then(function (res) {
          vm.flag = false;
          var data = res.body.data;
          if (data.length === 0) {
            window.alert('查無商品，請重新輸入。');
            return false;
          }
          vm.products = data;
        }, function () {
          console.log('failed');
        });
      } else {
        window.alert('請輸入關鍵字。');
      }
    }
  }),
  watch: {}
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShoppingCart',
  data: function data() {
    return {
      token: this.$store.getters.getToken,
      userID: this.$store.getters.getUserID,
      userName: '',
      userEmail: this.$store.getters.getUserEmail,
      UserPhone: this.$store.getters.getUserPhone,
      userCounty: this.$store.getters.userCounty,
      userDistrict: this.$store.getters.userDistrict,
      UserAddress: this.$store.getters.getUserAddress,
      UserCash: 0,

      items: this.$store.getters.getCart,
      firstbuy: this.$store.getters.getFirstbuy,
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      invoiced: 1,
      invoiceFee: 0,
      invoiceOptions: [{ text: '不需發票', value: 1 }, { text: '二聯式發票', value: 2 }, { text: '三聯式發票', value: 3 }],
      shippinged: 'option',
      shippingFee: 0,
      shippingOptions: [],
      paymented: 5,
      paymentFee: 0,
      step1: true,
      step2: false,
      orderTotal: 0,
      discount: null,
      discountInput: false,
      invoiceShow: false,
      current_discount: 0,
      countyval: '',
      county: this.$store.getters.getCounty,
      districtData: this.$store.getters.getDistrict,
      district: [],
      districtval: this.$store.getters.getUserDistrict,
      addon: this.$store.getters.getAddon,
      flag: false,
      freeDelivery: 2000,
      free_delivery_set: 0,
      deliveryPricing: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getCart', 'getUserID', 'getUserName', 'getUserEmail', 'getCounty', 'getDistrict', 'getAddon', 'getCompanies']), {
    orderAmount: function orderAmount() {
      var total = 0;
      var invoice = this.invoiced;
      if (this.items) {
        total = this.items.reduce(function (prev, element) {
          return prev + element.price * element.quantity;
        }, 0);
      }
      switch (invoice) {
        case 1:
          this.invoiceFee = 0;
          break;
        case 2:
          this.invoiceFee = Math.ceil(total * 0.05);
          break;
        case 3:
          this.invoiceFee = Math.ceil(total * 0.05);
          break;
      }
      this.orderTotal = total;
      return total;
    },
    totalPoint: function totalPoint() {
      return this.items.reduce(function (prev, element) {
        return prev + element.point * element.quantity;
      }, 0);
    },
    cart_items: function cart_items() {
      var total = 0;
      if (this.items) {
        total = this.items.length;
      }
      return total;
    },
    getInvoiceFee: function getInvoiceFee() {
      var invoice = this.invoiced;
      var total = this.orderTotal;
      switch (invoice) {
        case 2:
          this.invoiceFee = Math.ceil(total * 0.05);
          break;
        case 3:
          this.invoiceFee = Math.ceil(total * 0.05);
          break;
      }
    },
    totalAmount: function totalAmount() {
      var total = parseInt(this.orderTotal);
      var invoiceFee = parseInt(this.invoiceFee);
      var shippingFee = parseInt(this.shippingFee);
      var paymentFee = parseInt(this.paymentFee);
      return total + invoiceFee + shippingFee + paymentFee - this.current_discount;
    }
  }),
  watch: {
    countyval: {
      handler: function handler(val, oldVal) {
        this.district = this.districtData[val - 1];
      },
      deep: true
    },
    items: {
      handler: function handler(val, oldVal) {
        var data = val;
        this.$store.dispatch('EDIT_TO_CART', data);
        this.changeDelivery();
      },
      deep: true
    },
    shippinged: {
      handler: function handler(val, oldVal) {
        switch (val) {
          case 'logistics':
            this.shippingFee = this.deliveryPricing.c_domestic;
            break;
          case 'post':
            this.shippingFee = this.deliveryPricing.p_domestic;
            break;
          case 'help_yourself':
            this.shippingFee = 0;
            break;
          case 'send_to_home':
            this.shippingFee = this.deliveryPricing.c_domestic;
            break;
          case 'send_to_home_free':
            this.shippingFee = 0;
            break;
          default:
            this.shippingFee = 0;
            break;
        }
      }
    },
    invoiced: {
      handler: function handler(val, oldVal) {
        if (val === 3) {
          this.invoiceShow = true;
        } else {
          this.invoiceShow = false;
        }
      }
    },
    paymented: {
      handler: function handler(val, oldVal) {
        switch (val) {
          case '1':
            this.paymentFee = 15;
            break;
          case '2':
            this.paymentFee = 15;
            break;
          case '3':
            var total = this.orderTotal;
            this.paymentFee = Math.ceil(total * 0.0275);
            break;
          case '4':
            this.paymentFee = 20;
            break;
          case '5':
            this.paymentFee = 0;
            break;
        }
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['DELETE_TO_CART', 'EDIT_TO_CART', 'ADD_TO_CART', 'CHECKOUT']), {
    getTotal: function getTotal() {
      return this.items.reduce(function (prev, element) {
        return prev + element.price * element.quantity;
      }, 0);
    },
    getTotalPoints: function getTotalPoints() {
      return this.items.reduce(function (prev, element) {
        return prev + element.point * element.quantity;
      }, 0);
    },
    usedDiscount: function usedDiscount() {
      var cash = parseInt(this.UserCash);
      var discount = parseInt(this.discount);
      if (discount > cash) {
        window.alert('您扣抵的金額超過回饋金，請輸入正確的金額。');
      } else {
        this.current_discount = discount;
        this.UserCash = cash - discount;
        this.discountInput = true;
      }
    },
    changeDelivery: function changeDelivery() {
      var points = this.getTotalPoints();

      if (points >= this.freeDelivery && this.free_delivery_set === 1) {
        this.shippingOptions = [{ text: '請選擇', value: 0, tx: 'option' }, { text: '宅配到府', value: 0, tx: 'send_to_home_free' }, { text: '郵局', value: 0, tx: 'post' }];
      } else {
        this.shippingOptions = [{ text: '請選擇', value: 0, tx: 'option' }, { text: '宅急便', value: this.deliveryPricing.c_domestic, tx: 'send_to_home' }, { text: '郵局', value: this.deliveryPricing.p_domestic, tx: 'post' }];
      }
    },
    nextStep: function nextStep() {
      var str = '';
      this.calculateFee();
      if (this.shippinged === 'option') {
        str += '請選擇配送方式。\n';
      } else if (!this.userID || !this.token) {
        str += '請先登入會員再進行結帳\n';
      } else if (this.items.length === 0) {
        str += '請先選擇商品。\n';
      }
      if (str === '') {
        this.step1 = false;
        this.step2 = true;
      } else {
        window.alert(str);
      }
    },
    onSubmit: function onSubmit() {
      var str = '';
      if (this.userName === '' || typeof this.userName === 'undefined') {
        str += '請填寫姓名。\n';
      } else if (this.UserPhone === '' || typeof this.UserPhone === 'undefined') {
        str += '請先填寫連絡電話。\n';
      } else if (this.paymented === '') {
        str += '請先選擇付款方式。\n';
      } else if (this.discount > 0 && this.discountInput === false) {
        str += '請先按下確認扣抵。\n';
      } else if (this.countyval === 0 && this.districtval === 0) {
        str += '請先填寫配送地址。\n';
      }
      if (str === '') {
        this.flag = true;
        this.$store.dispatch('CHECKOUT');
        document.getElementById('order-form').submit();
      } else {
        window.alert(str);
      }
    },
    calculateFee: function calculateFee() {
      var total = this.getTotal();
      if (total < this.freeDelivery && this.free_delivery_set === 1 || this.free_delivery_set === 0) {
        this.shippingFee = this.deliveryPricing.c_domestic;
      } else {
        this.shippingFee = 0;
      }
    },
    addToCart: function addToCart(row) {
      this.$store.dispatch('SAVE_ACTIVITY_ITEM', row.id);
      this.$store.dispatch('ADD_TO_CART', row);
    }
  }),
  mounted: function mounted() {
    var fid = this.items ? this.items[0].fid : '';
    this.countyval = this.$store.getters.getUserCounty;
    this.userName = this.$store.getters.getUserName;
    this.district = this.districtData[this.countyval - 1];
    this.UserCash = this.$store.getters.getUserCash;
    this.userID = this.$store.getters.getUserID;

    var company = JSON.parse(localStorage.getItem('companies'));
    var factory = company.find(function (item, index, array) {
      return item.m_factoryID === fid;
    });
    this.deliveryPricing = JSON.parse(factory.delivery);

    this.free_delivery_set = factory.free_delivery_set;
    if (factory.free_delivery_set === 1) {
      this.freeDelivery = factory.free_delivery;
    }
    this.changeDelivery();
    this.calculateFee();
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Store',
  data: function data() {
    return {
      storeData: '',
      keyword: '',
      companies: [],
      origincompanies: []
    };
  },

  mounted: function mounted() {
    var stories = JSON.parse(localStorage.getItem('companies'));
    this.companies = stories;
    this.origincompanies = stories;
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['GET_NEWS']), {
    SearchingStore: function SearchingStore() {
      var keyword = this.keyword;
      if (keyword !== '') {
        this.companies = this.origincompanies.filter(function (value) {
          return value.com_name.indexOf(keyword) >= 0;
        });
      } else {
        this.companies = this.origincompanies;
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    userID: 'getUserID'
  })),
  metaInfo: {
    title: '愛幫您-聯盟店家',
    meta: [{
      name: '愛幫您-聯盟店家',
      content: '這邊擁有最多元的聯盟店家選擇，且都經過平台層層把關。'
    }],
    link: [{
      rel: 'store',
      href: 'https://www.i80.com.tw/store'
    }]
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StoreProductView',
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      rowData: {},
      orderNumber: 1,
      id: '',
      shareLink: '',
      company: {},
      items: this.$store.getters.getCart,
      firstbuy: this.$store.getters.getFirstbuy,
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    };
  },

  mounted: function mounted() {
    var id = this.$route.params.id;
    var fid = this.$route.params.fid;
    this.id = id;
    this.companyid = fid;
    var companies = JSON.parse(localStorage.getItem('companies'));
    if (companies.length > 0) {
      this.company = companies.find(function (item, index, array) {
        return item.m_factoryID === fid;
      });
    }
    var shareid = this.$route.params.shareid;
    if (shareid) {
      this.$store.dispatch('SET_SHARE_ID', shareid);
      localStorage.setItem('shareid', shareid);
    } else {
      shareid = localStorage.getItem('userId');
    }
    this.shareLink = 'https://www.i80.com.tw/store/product/' + id + '/' + fid + '/' + shareid;
  },
  created: function created() {
    var id = this.$route.params.id;
    this.$http.get(this.apiurl + 'api/getProductID/' + id).then(function (res) {
      this.rowData = res.body.data[0];
    }, function () {
      console.log('loading products is failed.');
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['SET_PRODUCTS', 'SET_SHARE_ID']), {
    addToCart: function addToCart(row) {
      var cart = this.items;
      if (cart.length > 0) {
        if (cart[0].fid !== row.fid) {
          window.alert('平台採單店結帳，請先進行結帳再購買其他店家商品謝謝');
          return false;
        }
      }
      row.maximum = 20;
      this.$store.dispatch('SAVE_ACTIVITY_ITEM', row.id);
      this.$store.dispatch('ADD_TO_CART', row);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    popular: 'getPopular'
  })),
  watch: {
    orderNumber: {
      handler: function handler(val, oldVal) {
        this.rowData.quantity = val;
      }
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StoreView',
  data: function data() {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      originProduct: Object,
      products: Object,
      rowData: {},
      userID: this.$store.getters.getUserID,
      paginate: ['products'],
      keyword: '',
      category: [],
      categorySelected: 0
    };
  },

  created: function created() {
    var id = this.$route.params.id;
    var vm = this;
    vm.$http.get(this.apiurl + 'api/getCategory/' + id).then(function (res) {
      var category = res.body.data;
      category.forEach(function (value, index) {
        value.id = value.products_id;
        value.name = value.product_title;
      });
      vm.category = category;
    }, function () {});

    vm.$http.get(this.apiurl + 'api/getProduct/' + id).then(function (res) {
      vm.products = res.body.data.sort(function (a, b) {
        return a.sorting - b.sorting;
      });
      vm.originProduct = vm.products;
    }, function () {});
    var data = this.loadCompany(id);
    this.rowData = data[0];
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getCompanies'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['ADD_TO_CART']), {
    addToCart: function addToCart(row) {
      window.alert('已加入購物車中');
      this.$store.dispatch('ADD_TO_CART', row);
    },
    loadCompany: function loadCompany(id) {
      var companies = JSON.parse(window.localStorage.getItem('companies'));

      return companies.filter(function (val) {
        return parseInt(val.comid) === parseInt(id);
      });
    },
    ProductSearch: function ProductSearch() {
      var keyword = this.keyword;
      if (keyword !== '') {
        this.products = this.originProduct;
        this.products = this.products.filter(function (value) {
          return value.name.indexOf(keyword) >= 0;
        });
      } else {}
    }
  }),
  watch: {
    categorySelected: {
      handler: function handler(val, oldVal) {
        if (val === '') {
          this.products = this.originProduct;
        } else {
          var products = this.originProduct;
          this.products = products.filter(function (value) {
            return value.parent_id === val;
          });
        }
      }
    }
  },
  metaInfo: {
    title: '愛幫您-聯盟店家',
    meta: [{
      name: '愛幫您-聯盟店家',
      content: '這邊擁有最多元的聯盟店家選擇，且都經過平台層層把關。'
    }],
    link: [{
      rel: 'storeview',
      href: 'https://www.i80.com.tw/storeview'
    }]
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Success',
  data: function data() {
    return {
      rowData: {},
      shareLink: '',
      activityItem: ''
    };
  },

  mounted: function mounted() {
    var activityItem = parseInt(localStorage.getItem('activityitem'));

    var UserId = localStorage.getItem('userId');
    this.activityItem = activityItem;
    this.shareLink = 'https://www.i80.com.tw/product/' + activityItem + '/' + UserId;
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['CLEAR_FIRST_BUY'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    UserId: 'getUserID',
    firstbuy: 'getFirstbuy'
  }))
});

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 26,
	"./af.js": 26,
	"./ar": 33,
	"./ar-dz": 27,
	"./ar-dz.js": 27,
	"./ar-kw": 28,
	"./ar-kw.js": 28,
	"./ar-ly": 29,
	"./ar-ly.js": 29,
	"./ar-ma": 30,
	"./ar-ma.js": 30,
	"./ar-sa": 31,
	"./ar-sa.js": 31,
	"./ar-tn": 32,
	"./ar-tn.js": 32,
	"./ar.js": 33,
	"./az": 34,
	"./az.js": 34,
	"./be": 35,
	"./be.js": 35,
	"./bg": 36,
	"./bg.js": 36,
	"./bm": 37,
	"./bm.js": 37,
	"./bn": 38,
	"./bn.js": 38,
	"./bo": 39,
	"./bo.js": 39,
	"./br": 40,
	"./br.js": 40,
	"./bs": 41,
	"./bs.js": 41,
	"./ca": 42,
	"./ca.js": 42,
	"./cs": 43,
	"./cs.js": 43,
	"./cv": 44,
	"./cv.js": 44,
	"./cy": 45,
	"./cy.js": 45,
	"./da": 46,
	"./da.js": 46,
	"./de": 49,
	"./de-at": 47,
	"./de-at.js": 47,
	"./de-ch": 48,
	"./de-ch.js": 48,
	"./de.js": 49,
	"./dv": 50,
	"./dv.js": 50,
	"./el": 51,
	"./el.js": 51,
	"./en-au": 52,
	"./en-au.js": 52,
	"./en-ca": 53,
	"./en-ca.js": 53,
	"./en-gb": 54,
	"./en-gb.js": 54,
	"./en-ie": 55,
	"./en-ie.js": 55,
	"./en-nz": 56,
	"./en-nz.js": 56,
	"./eo": 57,
	"./eo.js": 57,
	"./es": 60,
	"./es-do": 58,
	"./es-do.js": 58,
	"./es-us": 59,
	"./es-us.js": 59,
	"./es.js": 60,
	"./et": 61,
	"./et.js": 61,
	"./eu": 62,
	"./eu.js": 62,
	"./fa": 63,
	"./fa.js": 63,
	"./fi": 64,
	"./fi.js": 64,
	"./fo": 65,
	"./fo.js": 65,
	"./fr": 68,
	"./fr-ca": 66,
	"./fr-ca.js": 66,
	"./fr-ch": 67,
	"./fr-ch.js": 67,
	"./fr.js": 68,
	"./fy": 69,
	"./fy.js": 69,
	"./gd": 70,
	"./gd.js": 70,
	"./gl": 71,
	"./gl.js": 71,
	"./gom-latn": 72,
	"./gom-latn.js": 72,
	"./gu": 73,
	"./gu.js": 73,
	"./he": 74,
	"./he.js": 74,
	"./hi": 75,
	"./hi.js": 75,
	"./hr": 76,
	"./hr.js": 76,
	"./hu": 77,
	"./hu.js": 77,
	"./hy-am": 78,
	"./hy-am.js": 78,
	"./id": 79,
	"./id.js": 79,
	"./is": 80,
	"./is.js": 80,
	"./it": 81,
	"./it.js": 81,
	"./ja": 82,
	"./ja.js": 82,
	"./jv": 83,
	"./jv.js": 83,
	"./ka": 84,
	"./ka.js": 84,
	"./kk": 85,
	"./kk.js": 85,
	"./km": 86,
	"./km.js": 86,
	"./kn": 87,
	"./kn.js": 87,
	"./ko": 88,
	"./ko.js": 88,
	"./ky": 89,
	"./ky.js": 89,
	"./lb": 90,
	"./lb.js": 90,
	"./lo": 91,
	"./lo.js": 91,
	"./lt": 92,
	"./lt.js": 92,
	"./lv": 93,
	"./lv.js": 93,
	"./me": 94,
	"./me.js": 94,
	"./mi": 95,
	"./mi.js": 95,
	"./mk": 96,
	"./mk.js": 96,
	"./ml": 97,
	"./ml.js": 97,
	"./mr": 98,
	"./mr.js": 98,
	"./ms": 100,
	"./ms-my": 99,
	"./ms-my.js": 99,
	"./ms.js": 100,
	"./my": 101,
	"./my.js": 101,
	"./nb": 102,
	"./nb.js": 102,
	"./ne": 103,
	"./ne.js": 103,
	"./nl": 105,
	"./nl-be": 104,
	"./nl-be.js": 104,
	"./nl.js": 105,
	"./nn": 106,
	"./nn.js": 106,
	"./pa-in": 107,
	"./pa-in.js": 107,
	"./pl": 108,
	"./pl.js": 108,
	"./pt": 110,
	"./pt-br": 109,
	"./pt-br.js": 109,
	"./pt.js": 110,
	"./ro": 111,
	"./ro.js": 111,
	"./ru": 112,
	"./ru.js": 112,
	"./sd": 113,
	"./sd.js": 113,
	"./se": 114,
	"./se.js": 114,
	"./si": 115,
	"./si.js": 115,
	"./sk": 116,
	"./sk.js": 116,
	"./sl": 117,
	"./sl.js": 117,
	"./sq": 118,
	"./sq.js": 118,
	"./sr": 120,
	"./sr-cyrl": 119,
	"./sr-cyrl.js": 119,
	"./sr.js": 120,
	"./ss": 121,
	"./ss.js": 121,
	"./sv": 122,
	"./sv.js": 122,
	"./sw": 123,
	"./sw.js": 123,
	"./ta": 124,
	"./ta.js": 124,
	"./te": 125,
	"./te.js": 125,
	"./tet": 126,
	"./tet.js": 126,
	"./th": 127,
	"./th.js": 127,
	"./tl-ph": 128,
	"./tl-ph.js": 128,
	"./tlh": 129,
	"./tlh.js": 129,
	"./tr": 130,
	"./tr.js": 130,
	"./tzl": 131,
	"./tzl.js": 131,
	"./tzm": 133,
	"./tzm-latn": 132,
	"./tzm-latn.js": 132,
	"./tzm.js": 133,
	"./uk": 134,
	"./uk.js": 134,
	"./ur": 135,
	"./ur.js": 135,
	"./uz": 137,
	"./uz-latn": 136,
	"./uz-latn.js": 136,
	"./uz.js": 137,
	"./vi": 138,
	"./vi.js": 138,
	"./x-pseudo": 139,
	"./x-pseudo.js": 139,
	"./yo": 140,
	"./yo.js": 140,
	"./zh-cn": 141,
	"./zh-cn.js": 141,
	"./zh-hk": 142,
	"./zh-hk.js": 142,
	"./zh-tw": 143,
	"./zh-tw.js": 143
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 236;

/***/ }),
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(313),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(308),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(307),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(302),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(294),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(301),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(310),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(293),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(315),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(316),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(284),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(312),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(291),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(298),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(311),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(314),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(235)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("權益與培訓專區")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('caption'), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((this.training), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(row.content)
      }
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.created_at))])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("主題")]), _vm._v(" "), _c('td', [_vm._v("檔案")]), _vm._v(" "), _c('td', [_vm._v("日期")])])])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-6"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("會員註冊")]), _vm._v(" "), _c('div', {
    staticClass: "register_form"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "account"
    }
  }, [_vm._v("*帳號(Email)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "請勿輸入特殊符號 如:&*_#等符號"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("*設定密碼")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [((_vm.passwordType ? 'password' : 'text') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "placeholder": "密碼",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.passwordType ? 'password' : 'text') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "placeholder": "密碼",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "placeholder": "密碼",
      "type": _vm.passwordType ? 'password' : 'text'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.displaypwd
    },
    on: {
      "click": function($event) {
        _vm.onChange($event)
      }
    }
  }), _vm._v(" 顯示密碼\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("*再次輸入密碼")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doublepassword),
      expression: "doublepassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "doublepassword",
      "placeholder": "再次輸入密碼"
    },
    domProps: {
      "value": (_vm.doublepassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doublepassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("*姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "請填寫中文本名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("*行動電話")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "id": "phone",
      "placeholder": "行動電話"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "idno"
    }
  }, [_vm._v("*身分證字號")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.identify),
      expression: "identify"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "id": "idno",
      "placeholder": "身分證字號"
    },
    domProps: {
      "value": (_vm.identify)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.identify = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countyval),
      expression: "countyval"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countyval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.county), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                                " + _vm._s(option.text) + "\n                                            ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.districtval),
      expression: "districtval"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.districtval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.district), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                                " + _vm._s(option.text) + "\n                                            ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "address"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("推薦人編號")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentid),
      expression: "parentid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": _vm.validated == 1,
      "id": "parentid",
      "placeholder": "推薦人編號"
    },
    domProps: {
      "value": (_vm.parentid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parentid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-9"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member_policy),
      expression: "member_policy"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.member_policy) ? _vm._i(_vm.member_policy, "1") > -1 : (_vm.member_policy)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.member_policy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.member_policy = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.member_policy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.member_policy = $$c
        }
      }
    }
  }), _vm._v("\n                                                我同意"), _c('a', {
    attrs: {
      "href": "/member_policy",
      "target": "_blink"
    }
  }, [_vm._v("遵守「會員條款」之內容")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement),
      expression: "agreement"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreement) ? _vm._i(_vm.agreement, "1") > -1 : (_vm.agreement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agreement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreement = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreement = $$c
        }
      }
    }
  }), _vm._v("\n                                                我同意"), _c('a', {
    attrs: {
      "href": "/privacy",
      "target": "_blink"
    }
  }, [_vm._v("「隱私權政策」之內容")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-9"
  }, [_c('pulse-loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": this.flag
    },
    on: {
      "click": function($event) {
        _vm.register()
      }
    }
  }, [_vm._v("註冊")])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/member"
    }
  }, [_vm._v("會員中心")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("註冊")])])
}]}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "banner_section"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carousel-example-generic",
      "data-ride": "carousel"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._l((_vm.homeSlide), function(row, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": row.image,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-caption"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(row.id) + "\n\t\t\t\t\t\t")])])
  })], 2), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _vm._m(3, false, false)])]), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _c('section', {
    staticClass: "step_section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "jcarousel-wrapper"
  }, [_c('div', {
    staticClass: "jcarousel"
  }, [_c('ul', [_c('li', {
    staticClass: "step_box"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('figure', {
    staticClass: "pic justify"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/index/3-1.png'
    }
  })]), _vm._v(" "), _vm._m(6, false, false)])]), _vm._v(" "), _c('li', {
    staticClass: "step_box"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('figure', {
    staticClass: "pic justify"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/index/3-2.jpg'
    }
  })]), _vm._v(" "), _vm._m(7, false, false)])]), _vm._v(" "), _c('li', {
    staticClass: "step_box"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('figure', {
    staticClass: "pic justify"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/index/3-3.jpg'
    }
  })]), _vm._v(" "), _vm._m(8, false, false)])]), _vm._v(" "), _c('li', {
    staticClass: "step_box"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('figure', {
    staticClass: "pic justify"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/index/3-4.jpg'
    }
  })]), _vm._v(" "), _vm._m(9, false, false)])])])]), _vm._v(" "), _c('a', {
    staticClass: "jcarousel-control-prev",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("‹")]), _vm._v(" "), _c('a', {
    staticClass: "jcarousel-control-next",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("›")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "news_section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h4', {
    staticClass: "title main_title session_title"
  }, [_vm._v("最新消息")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.news), function(row, index) {
    return _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "news_box"
    }, [_c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "day"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(row.c_date)))]), _vm._v(" "), _c('span', {
      staticClass: "month"
    }, [_vm._v(_vm._s(_vm._f("formatMonth")(row.c_date)) + "月")])]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.c_title))]), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("truncate")(row.c_content, 50)) + "\n\t\t\t\t\t\t\t\t"), _c('router-link', {
      staticClass: "pull-right more",
      attrs: {
        "to": '/news/' + index
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t了解更多"), _c('span', {
      staticClass: "glyphicon glyphicon-menu-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])])
  }))])]), _vm._v(" "), _c('section', {
    staticClass: "store_section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h4', {
    staticClass: "title main_title session_title"
  }, [_vm._v("合作廠商")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.companies), function(row, index) {
    return _c('div', {
      staticClass: "col-md-2 col-xs-6"
    }, [_c('div', {
      staticClass: "store_box"
    }, [_c('router-link', {
      attrs: {
        "to": '/store/' + row.comid
      }
    }, [_c('figure', {
      staticClass: "pic justify"
    }, [(row.com_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + row.com_image
      }
    }) : _vm._e()]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.com_name))])])], 1)])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carousel-example-generic",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-example-generic",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-example-generic",
      "data-slide-to": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item active"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/index/banner3.jpg",
      "alt": "i80愛幫您"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature_section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "feature_box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("即時成效")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("平台即時呈現銷售資訊與追踪工具讓您瞭解通路表現，是精準且穩定的網路平台。")]), _vm._v(" "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/operators"
    }
  }, [_vm._v("了解更多"), _c('span', {
    staticClass: "glyphicon glyphicon-menu-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-time icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "feature_box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("最高獎金")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("平台每件商品個人都享有10%的返利，推薦越多享受更多。")]), _vm._v(" "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/operators"
    }
  }, [_vm._v("了解更多"), _c('span', {
    staticClass: "glyphicon glyphicon-menu-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-usd icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "feature_box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("優質商品")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("平台負責把關所有上架商品，讓消費者放心購買。")]), _vm._v(" "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/operators"
    }
  }, [_vm._v("了解更多"), _c('span', {
    staticClass: "glyphicon glyphicon-menu-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-thumbs-up icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "feature_box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("服務專員")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("提供線上與實體客服，讓您快速了解平台與商品特色。")]), _vm._v(" "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/contact"
    }
  }, [_vm._v("了解更多"), _c('span', {
    staticClass: "glyphicon glyphicon-menu-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-user icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('h4', {
    staticClass: "title main_title"
  }, [_vm._v("i80：賺取回饋金三步驟")]), _vm._v(" "), _c('p', [_vm._v("加入平台並使用推廣連結分享商品，當網友由連結導入至推廣的商品完成購買，您就即可獲取回饋金。")]), _vm._v(" "), _c('p', [_vm._v("簡單三步驟，您也能成為網路推廣者，趕緊加入愛幫您的行列吧!")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default i80_btn",
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("免費加入會員")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', [_vm._v("我該如何選擇產品？")]), _vm._v(" "), _c('p', [_vm._v("加入愛幫您：找你喜歡、有興趣、或專長領域的商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', [_vm._v("我可以在哪裡推廣？")]), _vm._v(" "), _c('p', [_vm._v("可以透過個人社群軟體、部落格親友、拜訪等做宣傳")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', [_vm._v("我怎麼獲得獎金？")]), _vm._v(" "), _c('p', [_vm._v("透過分享後，只要有產生消費，系統就會立即計算獎金給您")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', [_vm._v("我該如何選擇產品？")]), _vm._v(" "), _c('p', [_vm._v("加入聯盟網：找你喜歡、有興趣、或專長的商品")])])
}]}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.rowData.name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 pull-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7 col-xs-12"
  }, [_c('figure', {
    staticClass: "pic"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": 'https://files.i80.com.tw/images/product/' + _vm.rowData.imageL
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.rowData.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rowData.short))]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled product_intro"
  }, [_c('li', {
    staticClass: "price_box"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.rowData.price))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('li', [_c('b', {
    staticClass: "title"
  }, [_vm._v("數量")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNumber),
      expression: "orderNumber"
    }],
    staticClass: "form-control amount",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderNumber = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.numbers), function(number) {
    return _c('option', {
      domProps: {
        "value": number
      }
    }, [_vm._v(_vm._s(number))])
  }))])]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addToCart(_vm.rowData)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 加入購物車\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": 'https://www.i80.com.tw/product/' + _vm.rowData.id,
      "data-share": "true",
      "data-width": "120",
      "data-show-faces": "false"
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("產品介紹")]), _vm._v(" "), _c('p', {
    staticClass: "editor",
    domProps: {
      "innerHTML": _vm._s(_vm.rowData.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fb-comments",
    attrs: {
      "data-href": "this.id",
      "data-num-posts": "2",
      "data-width": "100%"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_vm._v("購物商城")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', {
    staticClass: "title"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline payment"
  }, [_c('li', [_vm._v("信用卡")]), _vm._v(" "), _c('li', [_vm._v("ATM")]), _vm._v(" "), _c('li', [_vm._v("iBon")])])])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("聯盟經營者")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("內文")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("關於我們")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "active item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("聯盟推廣者")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('article', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("為甚麼要推廣i80?")]), _vm._v(" "), _c('div', {
    staticClass: "editor"
  }, [_vm._v("\n                      由於我們處於百物齊漲，唯獨薪水不增的時代，我們工作都是為了要賺錢養家，但是有沒有更好的方法邦你降低支出呢?\n                      目前有許多的通路都是剝削消費者居多並未考量消費者所需而設立，而我們愛幫您就是希望能提供第三方的公正平台來邦助消費者，\n                      邦助商品的把關與降低消費者的支出。"), _c('br'), _vm._v("那為甚麼消費者要推廣愛幫您呢?\n                      推廣i80的福利，首先自己加入i80就享有個人回饋，所以只要在i80平台消費是比外面還便宜的，\n                      此外透過您推薦的朋友加入後，往後任何消費我們都將再額外回饋廣告行銷費用給您而且這都是永久不變的。\n                      另外我們不時舉辦各種會員的活動與聚會，讓我們i80的會員們能像一個大家庭一樣，一起消費一起買到便宜又好的商品。\n                      ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "editor"
  }, [_vm._v("\n                      如果您覺得這個平台實在太好了，請先加入成為我們的會員，並介紹你的朋友讓他也加入成為會員，\n                      加入後您便是i80消費者聯盟的一份子。成為會員後，在聯盟的店家或是網路商品購買產品即有回饋點數。\n                      ")])])])])])])])
}]}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("商品查詢")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "navbar-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "關鍵字"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": this.flag
    },
    on: {
      "click": function($event) {
        _vm.SearchProduct()
      }
    }
  }, [_vm._v("查詢")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row clear"
  }, [_c('paginate', {
    staticClass: "paginate-langs",
    attrs: {
      "name": "products",
      "list": _vm.products,
      "per": 12,
      "tag": "div"
    }
  }, _vm._l((_vm.paginated('products')), function(item) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "product_box"
    }, [_c('figure', {
      staticClass: "pic justify"
    }, [_c('router-link', {
      attrs: {
        "to": '/product/' + item.id
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageM
      }
    })])], 1), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.price > 0) ? _c('p', {
      staticClass: "points"
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-gift",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(item.point) + "點\n      ")]) : _vm._e(), _vm._v(" "), (item.price > 0) ? _c('p', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))]) : _vm._e(), _vm._v(" "), (item.price > 0) ? _c('button', {
      staticClass: "addcart btn btn-default i80_btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.ADD_TO_CART(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-shopping-cart",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" 加入購物車\n      ")]) : _vm._e()])])
  }))], 1), _vm._v(" "), _c('center', [_c('nav', {
    attrs: {
      "aria-label": "Page navigation example"
    }
  }, [_c('paginate-links', {
    attrs: {
      "for": "products",
      "classes": {
        'ul': ['pagination', 'pagination-sm'],
        'li': 'page-item'
      }
    }
  })], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/store"
    }
  }, [_vm._v("商品查詢")])])])
}]}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.rowData.c_title))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('article', [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.rowData.c_title))]), _vm._v(" "), _c('div', {
    staticClass: "editor",
    domProps: {
      "innerHTML": _vm._s(_vm.rowData.c_content)
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("最新消息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("最新消息")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "active item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("主要消息")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("活動消息")])])])])])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item active",
    attrs: {
      "role": "presentation"
    }
  }), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/consume"
    }
  }, [_vm._v("消費紀錄")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/personal"
    }
  }, [_vm._v("基本資料")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/performance"
    }
  }, [_vm._v("回饋金查詢")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/bonus"
    }
  }, [_vm._v("領取紀錄")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/order"
    }
  }, [_vm._v("訂購紀錄")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/redeen"
    }
  }, [_vm._v("抵用券")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/team"
    }
  }, [_vm._v("組織查詢")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/training"
    }
  }, [_vm._v("會員權益與培訓")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/share"
    }
  }, [_vm._v("分享網址")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/agreement"
    }
  }, [_vm._v("合約中心")])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/member"
    }
  }, [_vm._v("會員中心")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("基本資料")])])
}]}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("訂購紀錄")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datepicker', {
    attrs: {
      "language": "zh",
      "format": "yyyy-MM"
    },
    model: {
      value: (_vm.choosemonth),
      callback: function($$v) {
        _vm.choosemonth = $$v
      },
      expression: "choosemonth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": this.searchFlag
    },
    on: {
      "click": function($event) {
        _vm.getConsume()
      }
    }
  }, [_vm._v("查詢")])])]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((this.consume), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.getDetail(row.trans_main_id)
        }
      }
    }, [_vm._v("明細")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.companyname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.t_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.t_point))]), _vm._v(" "), _c('td', [_vm._v("\n                    點數 " + _vm._s(row.sale_cash)), _c('br'), _vm._v("\n                    現金 " + _vm._s(row.receive_cash) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.c_date))]), _vm._v(" "), (row.PositionCode == '999999999' && row.checkstate == 0 && row.ordercheck != 'user_cancel') ? _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.cancel(row.trans_main_id)
        }
      }
    }, [_vm._v("取消")])]) : _c('td')])
  }))]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Fade Modal",
      "show": _vm.fadeModal,
      "effect": "fade",
      "width": "800"
    },
    on: {
      "update:show": function($event) {
        _vm.fadeModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("購物明細")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("品名")]), _vm._v(" "), _c('td', [_vm._v("售價")]), _vm._v(" "), _c('td', [_vm._v("點數")]), _vm._v(" "), _c('td', [_vm._v("數量")]), _vm._v(" "), _c('td', [_vm._v("金額小計")]), _vm._v(" "), _c('td', [_vm._v("購買日期")])])]), _vm._v(" "), _c('tbody', _vm._l((this.detail), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(row.product[0].product_title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.sale_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.sale_point))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ordernumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.sale_price * row.ordernumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.c_date))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fadeModal = false
      }
    }
  }, [_vm._v("關閉")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("訂單明細")]), _vm._v(" "), _c('td', [_vm._v("店家")]), _vm._v(" "), _c('td', [_vm._v("售價")]), _vm._v(" "), _c('td', [_vm._v("點數")]), _vm._v(" "), _c('td', [_vm._v("付款方式")]), _vm._v(" "), _c('td', [_vm._v("日期")]), _vm._v(" "), _c('td')])])
}]}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.rowData.name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-sm-12 col-xs-12 pull-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('figure', {
    staticClass: "pic"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": 'https://files.i80.com.tw/images/product/' + _vm.rowData.imageL
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.rowData.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rowData.short))]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled product_intro"
  }, [_c('li', {
    staticClass: "price_box"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.rowData.price))]), _vm._v(" "), _c('p', {
    staticClass: "points"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-gift"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t    " + _vm._s(_vm.rowData.point) + " 點\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('li', [_c('b', {
    staticClass: "title"
  }, [_vm._v("數量")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNumber),
      expression: "orderNumber"
    }],
    staticClass: "form-control amount",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderNumber = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.numbers), function(number) {
    return _c('option', {
      domProps: {
        "value": number
      }
    }, [_vm._v(_vm._s(number))])
  }))])]), _vm._v(" "), (_vm.company.balance >= _vm.rowData.price && _vm.company.com_shopping == 'Y') ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addToCart(_vm.rowData)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 加入購物車\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#exampleModalCenter"
    }
  }, [_vm._v("\n                  優惠方案\n                ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                分享到：\n                "), _c('social-sharing', {
    attrs: {
      "url": _vm.shareLink,
      "title": _vm.rowData.name,
      "description": _vm.rowData.name,
      "hashtags": "i80"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fab fa-facebook fa-2x"
          }), _vm._v(" Facebook\n                    ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "pinterest"
            }
          }, [_c('i', {
            staticClass: "fab fa-fw fa-2x fa-pinterest"
          }), _vm._v(" Pinterest\n                    ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "line"
            }
          }, [_c('i', {
            staticClass: "fab fa-line fa-2x"
          }), _vm._v(" Line\n                    ")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("產品介紹")]), _vm._v(" "), _c('p', {
    staticClass: "editor",
    domProps: {
      "innerHTML": _vm._s(_vm.rowData.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": _vm.shareLink,
      "data-share": "true",
      "data-width": "120",
      "data-show-faces": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fb-comments",
    attrs: {
      "data-href": _vm.id,
      "data-num-posts": "2",
      "data-width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-12 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("你可能會喜歡")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.popular), function(item, index) {
    return _c('div', {
      staticClass: "col-md-12 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "product_box"
    }, [_c('a', {
      attrs: {
        "href": '/product/' + item.id
      }
    }, [_c('figure', {
      staticClass: "pic"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageM
      }
    })])]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "points"
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-gift",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.point) + " 點\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))])])])
  }))])])])]), _vm._v(" "), _vm._m(4, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_vm._v("購物商城")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', {
    staticClass: "title"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline payment"
  }, [_c('li', [_vm._v("信用卡")]), _vm._v(" "), _c('li', [_vm._v("ATM")]), _vm._v(" "), _c('li', [_vm._v("iBon")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModalCenter",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("活動訊息")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n              愛幫您的會員您好，只要按下分享愛幫您將贈送給您免費商品。"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")])])])])])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("隱私權政策")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("隱私權政策")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("隱私權政策")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "/member_policy"
    }
  }, [_vm._v("會員條款")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('h3', {
    staticClass: "title hidden-xs hidden-sm"
  }, [_vm._v("隱私權政策")]), _vm._v(" "), _c('div', {
    staticClass: "editor"
  }, [_c('p', [_vm._v("愛幫您股份有限公司(以下簡稱 i80)非常重視您的隱私權，請您閱讀以下有關隱私權保護政策的更多內容：")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n壹、本政策涵蓋的內容包括：i80如何處理蒐集或收到的個人資料 (包括與您過去使用 i80產品及服務相關的資料）。個人資料是指得以識別您的身分且未公開的資料，如姓名、地址、電子郵件地址或電話號碼等。\n")]), _vm._v(" "), _c('p', [_vm._v("\n貳、本隱私權保護政策只適用於 i80公司及旗下關係企業等。本政策不適用於非 i80所有或控制的公司，也不適用於非 i80僱用或管理之人。\n")]), _vm._v(" "), _c('p', [_vm._v("\n參、資料蒐集及使用：\n")]), _vm._v(" "), _c('p', [_vm._v("\n一、在您註冊 i80帳號、使用 i80系統、產品或服務、瀏覽 i80網頁或某些合作夥伴的網頁，以及參加宣傳活動或贈獎遊戲時，i80會蒐集您的個人資料。i80也可能將商業夥伴或其他企業所提供的關於您的資訊與 i80所擁有的您的個人資料相結合。\n")]), _vm._v(" "), _c('p', [_vm._v("\n二、當您在 i80註冊時，我們會詢問您的姓名、電子郵件地址、出生年月日期、性別及郵遞區號等資料。在您使用某些特定服務時，我們可能還會詢問您的住址、身分證號碼以及您數位資產的相關資料。在您註冊 i80帳號並登入我們的服務後，我們就能辨別您的身分。 您得自由選擇是否提供個人資料給我們，但若特定資料欄位係屬必填欄位者，您若不提供該等資料則無法使用相關的i80系統、產品及服務。\n")]), _vm._v(" "), _c('p', [_vm._v("\n三、i80蒐集您與我們或我們的商業夥伴交易的資料，包括您使用我們所提供服務的相關資料。\n")]), _vm._v(" "), _c('p', [_vm._v("\n四、i80也自動接收並記錄您電腦和瀏覽器上的資料，包括 IP位址、cookie中的資料、軟體和硬體屬性以及您瀏覽的網頁紀錄。\n")]), _vm._v(" "), _c('p', [_vm._v("\n五、在您使用i80產品及服務期間，i80及其相關企業得於全球地區將資料用作以下用途：客製化廣告及您看到的網頁內容、滿足您對產品和服務的要求、改進我們的服務、聯絡您、進行研究，以及提供內部及外部客戶不載有個人資料之市場分析或業務報告。\n")]), _vm._v(" "), _c('p', [_vm._v("\n  肆、i80蒐集、處理及利用個人資料之特定目的如下：行銷業務、消費者、客戶管理與服務、資訊通訊服務、網路購物及其他電子商務服務、廣告和商業行為管理業務以及其他契約、類似契約或法律關係管理之事務或業務。\n")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n  伍、資料分享與揭露：除非是為了向您提供您所要求的產品或服務、獲得您的授權，或有以下情形，否則 i80不會向任何其他人士或非關係企業提供您的個人資料，或與之分享：\n")]), _vm._v(" "), _c('p', [_vm._v("\n一、我們向已簽署保密協議書之代表 i80執行業務或與我們共事的值得信賴的合作夥伴提供這些資料。這些公司可能會將您的個人資料用於協助 i80就我們和行銷夥伴所提供產品及服務的事宜，與您進行溝通。但這些公司無獨立權利分享這些資料。\n")]), _vm._v(" "), _c('p', [_vm._v("\n二、我們對傳票、法院命令或法律程序作出回應、取得或行使法律權利，或對訴訟上之請求提出防禦。\n")]), _vm._v(" "), _c('p', [_vm._v("\n三、我們認為為了調查和防止非法活動、涉嫌詐欺、對人身安全有潛在威脅的狀況、對i80服務條款的違反，或為了對上述情形採取應對措施，或法律另有規定，而有必要分享您的個人資料時。\n")]), _vm._v(" "), _c('p', [_vm._v("\n四、如果i80全部或部分業務被其他公司收購或合併，我們會將您的個人資料移轉給該公司。如果發生這種情況，i80會在您的個人資料被移轉且將適用不同的隱私權政策前通知您。\n")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n陸、i80會根據您的個人資料向您為行銷廣告：\n")]), _vm._v(" "), _c('p', [_vm._v("\n一、廣告主 (包括廣告遞送公司) 可能假定那些瀏覽、點閱行銷廣告或與廣告互動的人士符合行銷標準，例如特定地理區域內 18至24 歲的女性。 在您瀏覽行銷廣告或與廣告發生互動時，i80不會向廣告主提供您的任何個人資料。然而，一旦瀏覽廣告或與廣告發生互動，即表示您同意廣告主可能會假定您符合展示型廣告所使用的行銷標準。 i80廣告主包括金融服務提供者 (如銀行、保險代理人、證券經紀人及抵押貸款機構等) 和非金融公司 (如商店、航空公司及軟體公司等)。\n")]), _vm._v(" "), _c('p', [_vm._v("\n二、i80與各行各業的供應商、合作夥伴、廣告主及其他服務提供者共用Cookie： i80會在您的電腦上設定並存取i80cookie。i80允許在某些i80網頁上刊登廣告的其他公司在您的電腦上設定並存取cookie。其他公司將根據其自訂的隱私權政策使用其cookie，並非依據本政策。廣告主或其他公司不能存取i80的cookie。\n")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n柒：您可隨時查詢、閱覽、複製及修改個人 i80帳號資料，包括行銷偏好設定：\n")]), _vm._v(" "), _c('p', [_vm._v("\n一、i80得不定時在行銷偏好設定頁面上新增新類別的行銷訊息。\n")]), _vm._v(" "), _c('p', [_vm._v("\n二、瀏覽此頁面的使用者可選擇退出接收新類別的行銷訊息，或按照所收訊息中的指示取消訂閱這些訊息。\n")]), _vm._v(" "), _c('p', [_vm._v("\n三、i80保有權利向您傳送 i80服務相關的特定訊息 (如服務公告、管理訊息等)，這些訊息被視為您i80帳號的一部分，您無法選擇退出接收。\n")]), _vm._v(" "), _c('p', [_vm._v("\n  四、如果您要刪除您的i80帳號，請與我們聯繫。關於您的帳號刪除後，會保留在我們存檔紀錄中的資料。\n")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n  捌、機密性和安全性\n")]), _vm._v(" "), _c('p', [_vm._v("\n  一、i80會將有權存取您個人資料之員工限於我們合理相信是為了向您提供產品或服務或為了完成工作而需要取得這些資料的員工。\n")]), _vm._v(" "), _c('p', [_vm._v("\n  二、i80已採取符合法規要求的實體、電子和程序防護措施，以保護您個人資料的安全。\n")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n  玖、隱私權保護政策修訂\n")]), _vm._v(" "), _c('p', [_vm._v("\n  一、i80得不定時修訂本政策。\n")]), _vm._v(" "), _c('p', [_vm._v("\n  二、當i80在個人資料的處理上有重大變更時，會將通知傳送到您在i80帳號中指定的主要電子郵件地址，或在i80的網站上張貼告示。\n")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n  拾、如果您有任何問題或建議，請透過客服中心與i80聯繫。\n")])])])])])])])
}]}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("消費/代購紀錄")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datepicker', {
    attrs: {
      "language": "zh",
      "format": "yyyy-MM",
      "placeholder": "可查詢不同月份"
    },
    model: {
      value: (_vm.choosemonth),
      callback: function($$v) {
        _vm.choosemonth = $$v
      },
      expression: "choosemonth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": this.searchFlag
    },
    on: {
      "click": function($event) {
        _vm.getConsume()
      }
    }
  }, [_vm._v("查詢")])])]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('caption'), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((this.consume), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.getDetail(row.trans_main_id)
        }
      }
    }, [_vm._v("明細")])]), _vm._v(" "), (row.purchase_org_mid > 0) ? _c('td', [_vm._v("\n                    " + _vm._s(row.companyname)), _c('br'), _vm._v("\n                    代購給 " + _vm._s(row.purchase_org_mid) + "\n                  ")]) : _c('td', [_vm._v("\n                    " + _vm._s(row.companyname) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.t_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.t_point))]), _vm._v(" "), _c('td', [_vm._v("\n                    點數 " + _vm._s(row.sale_cash)), _c('br'), _vm._v("\n                    現金 " + _vm._s(row.receive_cash) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.c_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.sale_cash_left))]), _vm._v(" "), (row.checkstate == 'FCheckOut') ? _c('td', [_vm._v("\n                    已付款\n                  ")]) : _c('td', [_vm._v("\n                    未付款\n                  ")])])
  }))]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Fade Modal",
      "show": _vm.fadeModal,
      "effect": "fade",
      "width": "800"
    },
    on: {
      "update:show": function($event) {
        _vm.fadeModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("購物明細")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("品名")]), _vm._v(" "), _c('td', [_vm._v("售價")]), _vm._v(" "), _c('td', [_vm._v("點數")]), _vm._v(" "), _c('td', [_vm._v("數量")]), _vm._v(" "), _c('td', [_vm._v("金額小計")]), _vm._v(" "), _c('td', [_vm._v("購買日期")])])]), _vm._v(" "), _c('tbody', _vm._l((this.detail), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(row.product[0].product_title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.sale_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(row.sale_point * 100) / 100))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ordernumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.sale_price * row.ordernumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.c_date))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fadeModal = false
      }
    }
  }, [_vm._v("關閉")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("訂單明細")]), _vm._v(" "), _c('td', [_vm._v("店家")]), _vm._v(" "), _c('td', [_vm._v("售價")]), _vm._v(" "), _c('td', [_vm._v("點數")]), _vm._v(" "), _c('td', [_vm._v("付款方式")]), _vm._v(" "), _c('td', [_vm._v("日期")]), _vm._v(" "), _c('td', [_vm._v("點數餘額")]), _vm._v(" "), _c('td', [_vm._v("狀態")])])])
}]}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('center', [_c('form', {
    staticClass: "navbar-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入商家名稱"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.SearchingStore()
      }
    }
  }, [_vm._v("查詢")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.companies), function(row, index) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "store_list"
    }, [_c('div', {
      staticClass: "store_box"
    }, [_c('router-link', {
      attrs: {
        "to": '/store/' + row.comid
      }
    }, [_c('figure', {
      staticClass: "pic justify"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + row.com_image
      }
    })]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.com_name))]), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(row.county_name) + _vm._s(row.district_name) + _vm._s(row.com_address))])])], 1)])])
  })), _vm._v(" "), _vm._m(2, false, false)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/store"
    }
  }, [_vm._v("聯盟店家")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("店家列表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "aria-label": "..."
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(current)")])])]), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Next"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])])])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("聯絡我們")]), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_vm._v("您有任何需求要與本網站聯繫，請於下方表單填寫即可。我們有專人會儘速為您提供服務。")]), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("電話")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "電話"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("訊息")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "訊息",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-9"
  }, [_c('button', {
    staticClass: "btn btn-default i80_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.contact()
      }
    }
  }, [_vm._v("留言")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("聯絡我們")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("聯絡資訊")]), _vm._v(" "), _c('div', {
    staticClass: "contact_box"
  }, [_c('h5', [_vm._v("愛幫您股份有限公司")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled contact_info"
  }, [_c('li', [_vm._v("服務時間：週一至週五, 09:00 - 18:00")]), _vm._v(" "), _c('li', [_vm._v("服務電話：03-4593159 0909-413-131")]), _vm._v(" "), _c('li', [_vm._v("服務地址：桃園市中壢區吉長街14號")])])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "250",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "src": "https://maps.google.com.tw/maps?f=q&hl=zh-TW&geocode=&q=桃園市中壢區吉長街14號&z=16&output=embed&t="
    }
  })])
}]}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("組織查詢")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('section', [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membername),
      expression: "membername"
    }],
    attrs: {
      "type": "text",
      "placeholder": "請填寫姓名"
    },
    domProps: {
      "value": (_vm.membername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('datepicker', {
    attrs: {
      "language": "zh",
      "format": "yyyy-MM-dd",
      "placeholder": "請選擇日期"
    },
    model: {
      value: (_vm.choosemonth),
      callback: function($$v) {
        _vm.choosemonth = $$v
      },
      expression: "choosemonth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": this.searchFlag
    },
    on: {
      "click": function($event) {
        _vm.doFilter()
      }
    }
  }, [_vm._v("過濾")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("清除")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._l((this.team), function(row, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2 col-xs-3"
    }, [_vm._v("1-" + _vm._s(row.org_mid))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 col-xs-3"
    }, [_vm._v(_vm._s(row.org_name))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('p', {
      staticClass: "text-success"
    }, [_vm._v(_vm._s(row.email))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5 col-xs-6 col-xs-offset-6"
    }, [_vm._v(_vm._s(row.created_at))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, _vm._l((row.dwon2), function(data, idx) {
      return _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-2 col-xs-3"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-offset-2 col-md-10"
      }, [_vm._v("2-" + _vm._s(data.org_mid))])])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-2 col-xs-3"
      }, [_vm._v(_vm._s(data.org_name))]), _vm._v(" "), _c('div', {
        staticClass: "col-md-3 col-xs-4"
      }, [_c('p', {
        staticClass: "text-success"
      }, [_vm._v(_vm._s(data.email))])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-5 col-xs-6 col-xs-offset-6"
      }, [_vm._v(_vm._s(data.created_at))]), _vm._v(" "), _c('div', {
        staticClass: "col-md-12"
      }, _vm._l((data.down3), function(l3, idx) {
        return _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-2 col-xs-3"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-offset-4 col-md-10"
        }, [_vm._v("3-" + _vm._s(l3.org_mid))])])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2 col-xs-3"
        }, [_vm._v(_vm._s(l3.org_name))]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3 col-xs-4"
        }, [_c('p', {
          staticClass: "text-success"
        }, [_vm._v(_vm._s(l3.email))])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-5 col-xs-6 col-xs-offset-6"
        }, [_vm._v(_vm._s(l3.created_at))])])
      }))])
    }))])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-xs-3"
  }, [_vm._v("會員編號")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-3"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_vm._v("信箱")])])
}]}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("回饋金領取紀錄")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((this.bonus), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("formatMonth")(row.sdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.org_receive_bonus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.org_person_perfor))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.org_team_perfor))])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("月份")]), _vm._v(" "), _c('td', [_vm._v("總金額")]), _vm._v(" "), _c('td', [_vm._v("個人")]), _vm._v(" "), _c('td', [_vm._v("組織")])])])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "new_list"
  }, _vm._l((_vm.news), function(row, index) {
    return _c('div', {
      staticClass: "news_box"
    }, [_c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "day"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(row.c_date)))]), _vm._v(" "), _c('span', {
      staticClass: "month"
    }, [_vm._v(_vm._s(_vm._f("formatMonth")(row.c_date)) + "月")])]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.c_title))]), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("truncate")(row.c_content, 200)) + "\n                                    "), _c('router-link', {
      staticClass: "pull-right more",
      attrs: {
        "to": '/news/' + index
      }
    }, [_vm._v("\n                                    了解更多"), _c('span', {
      staticClass: "glyphicon glyphicon-menu-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  })), _vm._v(" "), _vm._m(3, false, false)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("最新消息")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("內容")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("最新消息")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "active item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("主要消息")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("活動消息")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "aria-label": "..."
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(current)")])])]), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Next"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])])])
}]}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 hidden-xs"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((this.latest), function(row, index) {
    return _c('div', {
      staticClass: "col-sm-12 col-xs-6"
    }, [_c('div', {
      staticClass: "store_box"
    }, [_c('router-link', {
      attrs: {
        "to": '/store/' + row.comid
      }
    }, [_c('figure', {
      staticClass: "img"
    }, [(row.com_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + row.com_image
      }
    }) : _vm._e()]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.com_name))]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v("電話: " + _vm._s(row.com_phone))]), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(row.c_website))])])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("進駐商城")]), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_vm._v("\n                        俗話說：「團結力量大」，現今台灣的消費者多數被財團剝削，將錢交到財閥手中，卻很少給消費者相對的回報。\n                        假若我們將消費者集結起來，運用團結的力量，即可改變現狀。讓獲利回饋給消費者以及讓我們的聯盟商消費圈更鞏固，體現「取之於社會，用之於社會」的理念。\n                    ")]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("進駐表單")]), _vm._v(" "), _c('div', {
    staticClass: "apply_form"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputCo"
    }
  }, [_vm._v("公司/店面名稱")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_name),
      expression: "com_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "公司/店面名稱",
      "required": ""
    },
    domProps: {
      "value": (_vm.com_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCoPhone"
    }
  }, [_vm._v("公司電話")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_phone),
      expression: "com_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "公司電話"
    },
    domProps: {
      "value": (_vm.com_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputUrl"
    }
  }, [_vm._v("公司簡介")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.introduction),
      expression: "introduction"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "公司簡介"
    },
    domProps: {
      "value": (_vm.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.introduction = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCoNum"
    }
  }, [_vm._v("統一編號")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_number),
      expression: "com_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "統一編號"
    },
    domProps: {
      "value": (_vm.com_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_number = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCoAdd"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "公司/店面地址"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputUrl"
    }
  }, [_vm._v("網址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_site),
      expression: "com_site"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "官方網址"
    },
    domProps: {
      "value": (_vm.com_site)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_site = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConName"
    }
  }, [_vm._v("聯絡人姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_name),
      expression: "contact_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "聯絡人姓名",
      "required": ""
    },
    domProps: {
      "value": (_vm.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("聯絡人手機")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_phone),
      expression: "contact_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "聯絡人手機",
      "required": ""
    },
    domProps: {
      "value": (_vm.contact_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("聯絡人信箱")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "聯絡人信箱",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "maxlength": "20",
      "placeholder": "請輸入您想要的密碼",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("負責人會員編號")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reliablemanid),
      expression: "reliablemanid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "負責人會員編號",
      "required": ""
    },
    domProps: {
      "value": (_vm.reliablemanid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reliablemanid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("商品類別")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCategory),
      expression: "productCategory"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "填寫商品類別",
      "required": ""
    },
    domProps: {
      "value": (_vm.productCategory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productCategory = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("點數額")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pricing),
      expression: "pricing"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pricing = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.pricingList), function(option) {
    return _c('option', {
      domProps: {
        "value": option.text
      }
    }, [_vm._v("\n                                                    " + _vm._s(option.text) + " 元\n                                                ")])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', {}, [_vm._v("填寫表單前請先閲讀合約，一經填寫表單視同同意合約規定！並願意遵守！")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": this.flag
    },
    on: {
      "click": function($event) {
        _vm.apply()
      }
    }
  }, [_vm._v("我要加入")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(2, false, false)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("加入聯盟")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("填寫表單")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "editor"
  }, [_vm._v("\n                      雙方合作方式為，愛幫您提供系統平台服務，給予聯盟商產品上刊與介紹，以及依據聯盟商活躍程度，提供曝光版面，另提供系統服務協助以利於聯盟商發展。"), _c('br'), _c('br'), _vm._v("\n                      聯盟商加入上架費六萬八千元整，首次限時加入享優惠價三萬一千元整，若重新上架費為十三萬元整。\n                      "), _c('strong', [_vm._v("聯盟正式方案者，付款方式統一為 ATM 或 臨櫃付款")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                      平台採預儲值系統最低金額以 10,000 元整，其儲值費用為聯盟商之產品成交時 發放回饋金抵扣之用，\n                      於合約執行期間點數額保留於愛幫您系統中平台代為發放給會員。"), _c('br'), _vm._v("當需與平台解除合約時，必須繳清所有欠費（上架費、行銷費、資訊費）以及扣除愛幫您額外給予之補助與福利後可將餘款退回給聯盟商。"), _c('br'), _vm._v("\n                      塡寫以下表單前，請先詳閱合約書，必要時可先下載紙本合約，一旦填寫，視為同意遵守合約條款的各項規定。\n                      "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/static/files/agreement.pdf",
      "target": "_blank"
    }
  }, [_vm._v("合約下載")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                      若聯盟商家採用租賃模式(非一次繳清者)，則每月固定費用及單筆成交手續費做收取，使用負責人信用卡綁定進行款項收取。\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputConName"
    }
  }, [_vm._v("31,000 聯盟首次優惠方案")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('a', {
    attrs: {
      "href": "https://p.ecpay.com.tw/EA81824"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://payment.ecpay.com.tw/Content/themes/WebStyle20170517/images/ecgo.png",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputConName"
    }
  }, [_vm._v("68,000 聯盟方案")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('a', {
    attrs: {
      "href": "https://p.ecpay.com.tw/941A9AF"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://payment.ecpay.com.tw/Content/themes/WebStyle20170517/images/ecgo.png",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputConName"
    }
  }, [_vm._v("130,000 聯盟方案")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://p.ecpay.com.tw/5799AAF"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://payment.ecpay.com.tw/Content/themes/WebStyle20170517/images/ecgo.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  })])])])
}]}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.rowData.name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-sm-12 col-xs-12 pull-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('router-link', {
    attrs: {
      "to": '/store/' + _vm.company.comid
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.company.com_name) + "\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('figure', {
    staticClass: "pic"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": 'https://files.i80.com.tw/images/product/' + _vm.rowData.imageL
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.rowData.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rowData.short))]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled product_intro"
  }, [_c('li', {
    staticClass: "price_box"
  }, [(_vm.rowData.price > 0) ? _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.rowData.price))]) : _vm._e(), _vm._v(" "), (_vm.rowData.point > 0) ? _c('p', {
    staticClass: "points"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-gift"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t    " + _vm._s(_vm.rowData.point) + " 點\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), (_vm.rowData.price > 0) ? _c('li', [_c('b', {
    staticClass: "title"
  }, [_vm._v("數量")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNumber),
      expression: "orderNumber"
    }],
    staticClass: "form-control amount",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderNumber = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.numbers), function(number) {
    return _c('option', {
      domProps: {
        "value": number
      }
    }, [_vm._v(_vm._s(number))])
  }))]) : _vm._e()]), _vm._v(" "), (_vm.company.com_shopping == 'Y') ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addToCart(_vm.rowData)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 加入購物車\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#exampleModalCenter"
    }
  }, [_vm._v("\n                  優惠方案\n                ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                分享到：\n                "), _c('social-sharing', {
    attrs: {
      "url": _vm.shareLink,
      "title": _vm.rowData.name,
      "description": _vm.rowData.name,
      "hashtags": "i80"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fab fa-facebook fa-2x"
          }), _vm._v(" Facebook\n                    ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "pinterest"
            }
          }, [_c('i', {
            staticClass: "fab fa-fw fa-2x fa-pinterest"
          }), _vm._v(" Pinterest\n                    ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "line"
            }
          }, [_c('i', {
            staticClass: "fab fa-line fa-2x"
          }), _vm._v(" Line\n                    ")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("產品介紹")]), _vm._v(" "), _c('p', {
    staticClass: "editor",
    domProps: {
      "innerHTML": _vm._s(_vm.rowData.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": _vm.shareLink,
      "data-share": "true",
      "data-width": "120",
      "data-show-faces": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fb-comments",
    attrs: {
      "data-href": _vm.id,
      "data-num-posts": "2",
      "data-width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-12 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("你可能會喜歡")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.popular), function(item, index) {
    return _c('div', {
      staticClass: "col-md-12 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "product_box"
    }, [_c('a', {
      attrs: {
        "href": '/product/' + item.id
      }
    }, [_c('figure', {
      staticClass: "pic"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageM
      }
    })])]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "points"
    }, [(item.point > 0) ? _c('span', {
      staticClass: "glyphicon glyphicon-gift",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.point) + " 點\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), (item.price > 0) ? _c('p', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))]) : _vm._e()])])
  }))])])])]), _vm._v(" "), _vm._m(4, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/store"
    }
  }, [_vm._v("聯盟店家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', {
    staticClass: "title"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline payment"
  }, [_c('li', [_vm._v("信用卡")]), _vm._v(" "), _c('li', [_vm._v("ATM")]), _vm._v(" "), _c('li', [_vm._v("iBon")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModalCenter",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("活動訊息")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n              愛幫您的會員您好，只要按下分享愛幫您將贈送給您免費商品。"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")])])])])])
}]}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("忘記密碼")]), _vm._v(" "), _c('div', {
    staticClass: "register_form"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("查詢密碼")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入您的Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v("\n                                        (若當初填寫並未正確，請撥電話由公司進行變更。)\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-9"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.findPassword()
      }
    }
  }, [_vm._v("查詢密碼")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("忘記密碼")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("內容")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("會員查詢")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "active item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("會員查詢")])])])])])
}]}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("回饋金查詢")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datepicker', {
    attrs: {
      "language": "zh",
      "format": "yyyy-MM",
      "placeholder": "可查詢不同月份"
    },
    model: {
      value: (_vm.choosemonth),
      callback: function($$v) {
        _vm.choosemonth = $$v
      },
      expression: "choosemonth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": this.searchFlag
    },
    on: {
      "click": function($event) {
        _vm.getPerformance()
      }
    }
  }, [_vm._v("查詢")])])]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((this.performance), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(row.level))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.org_mid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.org_name))]), _vm._v(" "), (row.level === 0) ? _c('td', [_vm._v("\n                  總額: " + _vm._s(row.price)), _c('br'), _vm._v("\n                  一般商品:" + _vm._s(row.bonusL)), _c('br'), _vm._v("\n                  指定商品:" + _vm._s(row.bonusH) + "\n                  ")]) : _c('td', [_vm._v(_vm._s(row.transaction[0].price))]), _vm._v(" "), (row.level === 0) ? _c('td', [_vm._v(_vm._s(row.point))]) : _c('td', [_vm._v(_vm._s(Math.round(row.transaction[0].point, 3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.percentage) + "%")]), _vm._v(" "), (row.level === 0) ? _c('td', [_vm._v("\n                    " + _vm._s(row.person_bonus) + "\n                  ")]) : _c('td', [_vm._v("\n                    " + _vm._s(Math.round(row.transaction[0].bonus * 100) / 100) + "\n                  ")])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\n                  最高可領金額: " + _vm._s(this.Minimum) + " 元"), _c('br'), _c('br'), _vm._v("\n                  個人回饋金: " + _vm._s(this.personal)), _c('br'), _vm._v("\n                  組織回饋金: " + _vm._s(Math.round(this.group * 100) / 100)), _c('br'), _vm._v("\n                  總計回饋金: " + _vm._s(Math.round(this.totalBonus, 3)) + " 元\n                ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("編號")]), _vm._v(" "), _c('td', [_vm._v("姓名")]), _vm._v(" "), _c('td', [_vm._v("總消費額")]), _vm._v(" "), _c('td', [_vm._v("總點數")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("回饋金")])])])
}]}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("合約中心")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('caption'), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((this.agreements), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'https://files.i80.com.tw/erp_version/demo/upload_files/contract/' + row.contract,
        "target": "_blank"
      }
    }, [_vm._v("下載")])]), _vm._v(" "), (!row.signed_at) ? _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-info",
      attrs: {
        "type": "button",
        "disabled": row.signed_status == 1
      },
      on: {
        "click": function($event) {
          _vm.agreement_signed(row.id, row.title)
        }
      }
    }, [_vm._v("我已同意合約內容並申請")])]) : _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.signed_at))]), _vm._v(" "), (row.signed_status == 1) ? _c('td', [_vm._v("\n                    " + _vm._s(row.confirm_at) + "\n                  ")]) : _c('td')])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("合約名稱")]), _vm._v(" "), _c('td', [_vm._v("檔案")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("簽署時間")]), _vm._v(" "), _c('td', [_vm._v("通過時間")])])])
}]}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "main_content"
  }, [_c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "top_header"
  }, [_c('ul', {
    staticClass: "list-unstyled list-inline pull-right"
  }, [(_vm.userID !== '') ? _c('li', {
    staticClass: "hidden-xs"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("登出")])]) : _vm._e(), _vm._v(" "), (_vm.userID !== '') ? _c('li', {
    staticClass: "hidden-xs"
  }, [_c('a', {
    attrs: {
      "href": "/member/consume"
    }
  }, [_vm._v("會員中心")])]) : _vm._e(), _vm._v(" "), (_vm.userID !== '') ? _c('li', [_vm._v("歡迎 " + _vm._s(this.userName))]) : _vm._e(), _vm._v(" "), (_vm.userID === '') ? _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": ".login_modal"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t登入 / 註冊")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default i80_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCartList()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t購物車("), (_vm.items) ? _c('span', [_vm._v(_vm._s(_vm.items.length))]) : _vm._e(), _vm._v(")\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCart),
      expression: "showCart"
    }],
    staticClass: "cart"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items !== ''),
      expression: "items !==''"
    }],
    staticClass: "cart_list"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      staticClass: "item",
      attrs: {
        "transition": "fade"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-5 col-xs-5"
    }, [_c('figure', {
      staticClass: "pic"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageL
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-7  col-xs-7"
    }, [_c('span', [_vm._v(_vm._s(item.price) + "x" + _vm._s(item.quantity))]), _vm._v(" "), _c('span', {
      staticClass: "glyphicon glyphicon-trash pull-right delete",
      on: {
        "click": function($event) {
          _vm.DELETE_TO_CART(item)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])])])])
  }))]), _vm._v(" "), _c('router-link', {
    staticClass: "checkout pull-right",
    attrs: {
      "to": '/cart'
    }
  }, [_c('button', {
    staticClass: "btn btn-default i80_btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("結帳去"), _c('span', {
    staticClass: "glyphicon glyphicon-arrow-right"
  })])])], 1)])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default navbar-static-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse main_menu",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.userID !== '') ? _c('li', {
    staticClass: "visible-xs"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("登出")])]) : _vm._e(), _vm._v(" "), (_vm.userID !== '') ? _c('li', {
    staticClass: "visible-xs"
  }, [_c('a', {
    attrs: {
      "href": "/member"
    }
  }, [_vm._v("會員中心")])]) : _vm._e(), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _vm._m(5, false, false), _vm._v(" "), _vm._m(6, false, false), _vm._v(" "), _vm._m(7, false, false), _vm._v(" "), _vm._m(8, false, false), _vm._v(" "), _c('hr')])])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _vm._m(9, false, false), _vm._v(" "), _c('div', {
    staticClass: "modal fade login_modal",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "gridSystemModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog  modal-sm",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(10, false, false), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login_account"
    }
  }, [_vm._v("帳號(Email)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "login_account",
      "placeholder": "帳號(Email)"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v("\n\t\t\t\t\t\t(忘記Email可至忘記密碼進行查詢)\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login_pwd"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "login_pwd",
      "placeholder": "密碼"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("登入")]), _vm._v(" "), _vm._m(11, false, false)])]), _vm._v(" "), _vm._m(12, false, false)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-unstyled list-inline"
  }, [_c('li', {
    staticClass: "hidden-xs"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-earphone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:034593159"
    }
  }, [_vm._v("03-4593159")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:0909413131"
    }
  }, [_vm._v("0909-413-131")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("愛幫您股份有限公司 統編:23882568")])]), _vm._v(" "), _c('li', {
    staticClass: "hidden-xs"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://maps.google.com/?q=台東縣關山鎮德高里永豐10之1號",
      "target": "_blank"
    }
  }, [_vm._v("台東縣關山鎮德高里永豐10之1號")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/i80earnyourmoney/"
    }
  }, [_vm._v("Facebook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed mobile_menu_btn",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "id": "logo",
      "href": "/"
    }
  }, [_c('h1', [_vm._v("i80愛幫您")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("最新消息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("關於我們"), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("關於i80")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("我們的會員")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("隱私權政策")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("使用條款")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_vm._v("購物商城")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/store"
    }
  }, [_vm._v("聯盟店家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/freetrial"
    }
  }, [_vm._v("立即體驗")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/operators"
    }
  }, [_vm._v("聯盟經營者")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/search/product"
    }
  }, [_vm._v("商品查詢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-12"
  }, [_c('div', {
    staticClass: "job_box"
  }, [_c('figure', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/homebottom.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("你想幫助更多的人在網上賺錢嗎？如果你對數位行銷有興趣和熱情，歡迎你加入我們！")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-12"
  }, [_c('div', {
    staticClass: "about_box"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("認識愛幫您")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("愛幫您是台灣專業聯盟行銷平台。我們提供推廣者至少10%以上的回饋，成效可即時查詢，\n\t\t\t\t\t\t\t\t具有自行代理的優質商品外，結合聯盟店家提供客制化服務，我們提供廠商使用成效收費模式，依據消費者實際購物來計算回饋金，\n\t\t\t\t\t\t\t\t有效降低您的行銷風險，提升報酬率。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("關於我們")]), _vm._v(" "), _c('ul', {
    staticClass: "submenu list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("關於我們")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/ourteam"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("我們的會員")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("隱私權政策")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/term"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("使用條款")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("購物商城")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("相關資訊")]), _vm._v(" "), _c('ul', {
    staticClass: "submenu list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/contact"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("聯絡我們")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/faq"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("FAQ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/store"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("聯盟商家")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("產品列表")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("加入Line@")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/index/i80line.png"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {}, [_c('ul', {
    staticClass: "list-unstyled visible-xs"
  }, [_c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-earphone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:034593159"
    }
  }, [_vm._v("(03)4593-159")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:0909413131"
    }
  }, [_vm._v("0909-413-131")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("drwateri80@gmail.com")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("台東縣關山鎮德高里永豐10之1號")]), _vm._v(" "), _c('li', [_vm._v("Copyright © 2016 愛幫您股份有限公司版權所有 法律顧問「宸穎律師事務所」")])]), _vm._v(" "), _c('p', {
    staticClass: "hidden-xs"
  }, [_vm._v("Copyright © 2016 愛幫您股份有限公司版權所有 營業人：賴發雲 統一編號：23882568")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-xs"
  }, [_vm._v("法律顧問「宸穎律師事務所」")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "gridSystemModalLabel"
    }
  }, [_vm._v("註冊 / 登入")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "href": "/forgotpass"
    }
  }, [_c('small', [_vm._v("忘記密碼")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("一般註冊")])])
}]}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("註冊會員身分驗證")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  })])
}]}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("個人資料")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.personalForm),
      expression: "!this.personalForm"
    }]
  }, [_c('table', {
    staticClass: "table table-bordered  table-nonfluid table-responsive"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("姓名 : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.personal.org_name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("編號 : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.personal.org_mid))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("帳號(電子信箱) : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.personal.email))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("聯絡電話 : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.personal.org_cellphone))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("註冊日期 : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.personal.created_at))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("上個審核日 : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.personal.validat))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("地址 : ")]), _vm._v(" "), _c('td', [(_vm.personal.org_country > 0 && _vm.personal.org_town) ? _c('div', [_vm._v("\n              " + _vm._s(this.county[_vm.personal.org_country].text + this.district[_vm.personal.org_country - 1][_vm.personal.org_town].text + _vm.personal.org_address) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_vm._m(0, false, false), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.personal.org_cash))])]), _vm._v(" "), _c('tr', [_vm._m(1, false, false), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.personal.org_cash))])]), _vm._v(" "), _c('tr', [_vm._m(2, false, false), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.personal.bonus_wallet) + " (達成任務可兌換回點數餘額)")])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.oepnForm()
      }
    }
  }, [_vm._v("編輯資料")])])])])]), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("會員注意事項")]), _vm._v(" "), _c('p', [_vm._v("\n  任何會員若要退出愛幫您，需要將原先之補助與福利扣除後，可以將點數領回。\n")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.personalForm),
      expression: "this.personalForm"
    }]
  }, [_c('table', {
    staticClass: "table table-bordered  table-nonfluid table-responsive"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("姓名 : ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("編號 : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.personal.org_mid))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("帳號(電子信箱) : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.personal.email))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("聯絡電話 : ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("密碼 : ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v("(若無需要更正，留空白即可)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("密碼確認 : ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("地址 : ")]), _vm._v(" "), _c('td', [(_vm.personal.org_country > 0 && _vm.personal.org_town >= 0) ? _c('div', [_vm._v("\n                " + _vm._s(this.county[_vm.personal.org_country].text + this.district[_vm.personal.org_country - 1][_vm.personal.org_town].text + _vm.personal.org_address) + "\n              ")]) : _vm._e()])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editPersonal()
      }
    }
  }, [_vm._v("確認編輯")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("取消")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "label label-default"
  }, [_vm._v("點數餘額 : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "label label-default"
  }, [_vm._v("點數餘額 : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "label label-default"
  }, [_vm._v("活動集寶箱 : ")])])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-1 col-sm-10 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("立即填寫表單，成為聯盟商城的一份子")]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("登入表單")]), _vm._v(" "), _c('div', {
    staticClass: "apply_form"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputCo"
    }
  }, [_vm._v("公司/店面名稱")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_name),
      expression: "com_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "公司/店面名稱",
      "required": ""
    },
    domProps: {
      "value": (_vm.com_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCoPhone"
    }
  }, [_vm._v("公司電話")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_phone),
      expression: "com_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "公司電話"
    },
    domProps: {
      "value": (_vm.com_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_phone = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countyval),
      expression: "countyval"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countyval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.county), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                                    " + _vm._s(option.text) + "\n                                                ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.districtval),
      expression: "districtval"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.districtval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.district), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                                    " + _vm._s(option.text) + "\n                                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "address"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "公司/店面地址"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputUrl"
    }
  }, [_vm._v("網址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_site),
      expression: "com_site"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "官方網址"
    },
    domProps: {
      "value": (_vm.com_site)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_site = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConName"
    }
  }, [_vm._v("聯絡人姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_name),
      expression: "contact_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "聯絡人姓名",
      "required": ""
    },
    domProps: {
      "value": (_vm.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("聯絡人手機")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_phone),
      expression: "contact_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "聯絡人手機",
      "required": ""
    },
    domProps: {
      "value": (_vm.contact_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("聯絡人信箱(帳號)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "聯絡人信箱",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "maxlength": "20",
      "placeholder": "請輸入您想要的密碼",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("負責人會員編號")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reliablemanid),
      expression: "reliablemanid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "負責人會員編號",
      "required": ""
    },
    domProps: {
      "value": (_vm.reliablemanid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reliablemanid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("商品類別")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCategory),
      expression: "productCategory"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "填寫商品類別",
      "required": ""
    },
    domProps: {
      "value": (_vm.productCategory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productCategory = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.i_read_agreement),
      expression: "i_read_agreement"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.i_read_agreement) ? _vm._i(_vm.i_read_agreement, null) > -1 : (_vm.i_read_agreement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.i_read_agreement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.i_read_agreement = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.i_read_agreement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.i_read_agreement = $$c
        }
      }
    }
  }), _vm._v("\n                                  「我已詳細閱讀 "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/static/files/agreement.pdf",
      "target": "_blank"
    }
  }, [_vm._v("聯盟合約")]), _vm._v(" 內容」\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": this.flag
    },
    on: {
      "click": function($event) {
        _vm.apply()
      }
    }
  }, [_vm._v("確認申請")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("加入聯盟")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("填寫表單")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "editor"
  }, [_vm._v("\n                        現在愛幫您平台提供一個免費三個月的體驗機會，讓您能夠與我們一同合作擴大消費市場，加入之後您可以體驗我們的網站及 APP 的服務支援，\n                        並將商品推廣給我們的平台會員，讓您的商品快速擴展於平台。"), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                        接下來需要您先填寫貴公司相關的資料表格，系統將會為您建立一組登入帳號，方便您進入我們的管理平台，以及請閱讀相關合約「\n                        "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/static/files/agreement.pdf",
      "target": "_blank"
    }
  }, [_vm._v("聯盟合約下載")]), _vm._v("」\n                    ")])
}]}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("FAQ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-smmd-offset-2 col-sm-8"
  }, [_c('h4', {
    staticClass: "text-center title"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion faq",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default faq_box"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "headingOne"
    }
  }, [_c('h4', {
    staticClass: "panel-title title"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_vm._v("\n                                      會員回饋金何時發放?\n                                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseOne",
      "role": "tabpanel",
      "aria-labelledby": "headingOne"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                                  會員於上個月進行消費所產生的點數，以及包含推薦的會員消費，系統會統一進行計算後於隔月15號一併發放回饋金給會員，並且保存於會員中心的紀錄中。\n                              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default faq_box"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "headingTwo"
    }
  }, [_c('h4', {
    staticClass: "panel-title title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseTwo",
      "aria-expanded": "false",
      "aria-controls": "collapseTwo"
    }
  }, [_vm._v("\n                              會員如何進行消費與分享?\n                              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseTwo",
      "role": "tabpanel",
      "aria-labelledby": "headingTwo"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                                  您只要註冊帳號後系統將會給你一組會員編號，您可以透過分享網址船給您的朋友，讓朋友進行註冊後就算是完成推薦的動作了，爾後當您的朋友購買任何商品都會直接回饋給您。\n                              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default faq_box"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "headingThree"
    }
  }, [_c('h4', {
    staticClass: "panel-title title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseThree",
      "aria-expanded": "false",
      "aria-controls": "collapseThree"
    }
  }, [_vm._v("\n                                  如果我有認識的好的商品或店家，可以進行推薦嗎?\n                                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseThree",
      "role": "tabpanel",
      "aria-labelledby": "headingThree"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                                  一定可以的!我們的平台需要優質的商品來提供給會員，因此歡迎您提供我們商家的連絡資訊與商品項目，來讓我們進行接洽服務更多會員。\n                              ")])])])])])])])])])
}]}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("抵用券")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datepicker', {
    attrs: {
      "language": "zh",
      "format": "yyyy-MM",
      "placeholder": "可查詢不同月份"
    },
    model: {
      value: (_vm.choosemonth),
      callback: function($$v) {
        _vm.choosemonth = $$v
      },
      expression: "choosemonth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": this.searchFlag
    },
    on: {
      "click": function($event) {
        _vm.getConsume()
      }
    }
  }, [_vm._v("查詢")])])]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('caption'), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((this.redeen), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(row.com_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.product_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.quota - row.redeen_times))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.created_at))])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("店家")]), _vm._v(" "), _c('td', [_vm._v("售價")]), _vm._v(" "), _c('td', [_vm._v("價值")]), _vm._v(" "), _c('td', [_vm._v("剩餘張數")]), _vm._v(" "), _c('td', [_vm._v("時間")])])])
}]}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("分享網址")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("網址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qr))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("QRCode")]), _vm._v(" "), _c('td', [_c('qr-code', {
    attrs: {
      "text": _vm.qr
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.rowData.com_name))])]), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.rowData.com_name))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-3 col-xs-12"
  }, [_c('div', {
    staticClass: "store_contact"
  }, [_c('figure', {
    staticClass: "pic pull-left text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": 'https://files.i80.com.tw/images/product/' + _vm.rowData.com_resize_image
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "lcass": "tel"
    }
  }, [_vm._v("電話：" + _vm._s(_vm.rowData.com_phone))]), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v("地址：" + _vm._s(_vm.rowData.county_name) + _vm._s(_vm.rowData.district_name) + _vm._s(_vm.rowData.com_address))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rowData.c_website != ''),
      expression: "rowData.c_website!=''"
    }],
    staticClass: "website"
  }, [_vm._v("\n                網址："), _c('a', {
    attrs: {
      "href": _vm.rowData.c_website,
      "target": "_blink"
    }
  }, [_vm._v("點我進入網站")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-sm-9 col-xs-12",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('p', {
    staticClass: "edit"
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.rowData.website_intro)
    }
  }), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "navbar-form navbar-right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categorySelected),
      expression: "categorySelected"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.categorySelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.category), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "關鍵字"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.ProductSearch()
      }
    }
  }, [_vm._v("查詢")])]), _vm._v(" "), _c('div', {
    staticClass: "row clear"
  }, [_c('paginate', {
    staticClass: "paginate-langs",
    attrs: {
      "name": "products",
      "list": _vm.products,
      "per": 12,
      "tag": "div"
    }
  }, _vm._l((_vm.paginated('products')), function(item) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "product_box"
    }, [_c('figure', {
      staticClass: "pic justify"
    }, [_c('router-link', {
      attrs: {
        "to": '/store/product/' + item.id + '/' + _vm.rowData.m_factoryID + '/' + _vm.userID
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageM
      }
    })])], 1), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.rowData.point > 0) ? _c('p', {
      staticClass: "points"
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-gift",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(item.point) + "點")]) : _vm._e(), _vm._v(" "), (_vm.rowData.price > 0) ? _c('p', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))]) : _vm._e(), _vm._v(" "), (_vm.rowData.balance >= item.price && _vm.rowData.com_shopping == 'Y') ? _c('button', {
      staticClass: "addcart btn btn-default i80_btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.ADD_TO_CART(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-shopping-cart",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" 加入購物車\n      ")]) : _vm._e()])])
  }))], 1), _vm._v(" "), _c('center', [_c('nav', {
    attrs: {
      "aria-label": "Page navigation example"
    }
  }, [_c('paginate-links', {
    attrs: {
      "for": "products",
      "classes": {
        'ul': ['pagination', 'pagination-sm'],
        'li': 'page-item'
      }
    }
  })], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/store"
    }
  }, [_vm._v("聯盟店家")])])
}]}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://store.i80.com.tw/Trans.php",
      "id": "order-form",
      "method": "POST"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step1),
      expression: "step1"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippinged),
      expression: "shippinged"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "delivery"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shippinged = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.shippingOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.tx
      }
    }, [_vm._v(_vm._s(option.text))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiced),
      expression: "invoiced"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "invoice"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.invoiced = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.invoiceOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                          " + _vm._s(option.text) + "\n                                      ")])
  }))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceShow),
      expression: "invoiceShow"
    }],
    staticClass: "row"
  }, [_vm._m(5, false, false), _vm._v(" "), _vm._m(6, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "cart_list"
  }, [_vm._m(7, false, false), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "list_item"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-2 hidden-xs"
    }, [_c('figure', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageL
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-3"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('span', [_vm._v(_vm._s(item.price) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('span', [_vm._v(_vm._s(item.point) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantity),
        expression: "item.quantity"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((item.maximum), function(number) {
      return _c('option', {
        domProps: {
          "value": number
        }
      }, [_vm._v(_vm._s(number))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-2"
    }, [_c('span', [_vm._v(_vm._s(item.point * item.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-2"
    }, [_c('span', [_vm._v(_vm._s(item.price * item.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('h5', {
      staticClass: "title",
      on: {
        "click": function($event) {
          _vm.DELETE_TO_CART(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-trash"
    })])])])])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.totalPoint >= 1000) ? _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("加購專區")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.addon), function(item, index) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-3 col-xs-3"
    }, [_c('div', {
      staticClass: "product_box"
    }, [_c('a', {
      attrs: {
        "href": '/product/' + item.id
      }
    }, [_c('figure', {
      staticClass: "pic"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageM
      }
    })])]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))]), _vm._v(" "), _c('button', {
      staticClass: "addcart btn btn-default i80_btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.addToCart(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-shopping-cart",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" 加入購物車\n            \t\t\t\t\t\t\t\t\t\t")])])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "total_list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-7 col-sm-5 col-xs-12"
  }, [_c('p', [_vm._v("共" + _vm._s(_vm.cart_items) + "件，回饋點數: " + _vm._s(_vm.totalPoint) + "點")])]), _vm._v(" "), _vm._m(8, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.orderAmount))])])]), _vm._v(" "), _vm._m(9, false, false), _vm._v(" "), _vm._m(10, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.shippingFee))])])]), _vm._v(" "), _vm._m(11, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.invoiceFee))])])]), _vm._v(" "), _vm._m(12, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('span', [_vm._v(_vm._s(_vm.totalAmount))])])])])], 2), _vm._v(" "), _c('h5', {
    staticClass: "title"
  }, [_vm._v("注意事項")]), _vm._v(" "), _vm._m(13, false, false), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.nextStep()
      }
    }
  }, [_vm._v("下一步")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step2),
      expression: "step2"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymented),
      expression: "paymented"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.paymented, "1")
    },
    on: {
      "change": function($event) {
        _vm.paymented = "1"
      }
    }
  }), _vm._v("\n                              ATM轉帳：使用實體ATM轉帳，手續費 15元\n                          ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymented),
      expression: "paymented"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.paymented, "2")
    },
    on: {
      "change": function($event) {
        _vm.paymented = "2"
      }
    }
  }), _vm._v("\n                              網路ATM：需備有讀卡機，手續費 15元\n                          ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymented),
      expression: "paymented"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.paymented, "3")
    },
    on: {
      "change": function($event) {
        _vm.paymented = "3"
      }
    }
  }), _vm._v("\n                              信用卡：手續費 2.75%\n                          ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymented),
      expression: "paymented"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.paymented, "4")
    },
    on: {
      "change": function($event) {
        _vm.paymented = "4"
      }
    }
  }), _vm._v("\n                              超商付款：7-11 iBon付款，手續費 20元\n                          ")])]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymented),
      expression: "paymented"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "value": "5",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.paymented, "5")
    },
    on: {
      "change": function($event) {
        _vm.paymented = "5"
      }
    }
  }), _vm._v("\n                              貨到付款\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cart_list"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("購物明細")]), _vm._v(" "), _vm._m(14, false, false), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "list_item"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-2 hidden-xs"
    }, [_c('figure', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageL
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-3"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('span', [_vm._v(_vm._s(item.price) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('span', [_vm._v(_vm._s(item.point) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 col-xs-1"
    }, [_c('span', [_vm._v(_vm._s(item.quantity) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-2"
    }, [_c('span', [_vm._v(_vm._s(item.point * item.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 col-xs-2"
    }, [_c('span', [_vm._v(_vm._s(item.price * item.quantity))])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": "pid[]"
      },
      domProps: {
        "value": item.id
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": "qty[]"
      },
      domProps: {
        "value": item.quantity
      }
    })])])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.UserCash > 0) ? _c('div', {
    staticClass: "discount"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 col-xs-3 label label-danger text-right",
    attrs: {
      "for": "inputDiscount"
    }
  }, [_vm._v("使用回饋金")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": _vm.discountInput == 1 ? true : false,
      "placeholder": "請輸入扣抵金額"
    },
    domProps: {
      "value": (_vm.discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 col-xs-3"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.discountInput == 1 ? true : false
    },
    on: {
      "click": function($event) {
        _vm.usedDiscount()
      }
    }
  }, [_vm._v("確認扣抵")]), _vm._v("\n                                          餘額: " + _vm._s(_vm.UserCash) + " 元\n                                      ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "total_list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-7 col-sm-5 col-xs-12"
  }, [_c('p', [_vm._v("共 " + _vm._s(_vm.cart_items) + " 件，回饋點數: " + _vm._s(_vm.totalPoint) + " 點")])]), _vm._v(" "), _vm._m(15, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.orderAmount))])])]), _vm._v(" "), _vm._m(16, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.discount || 0))])])]), _vm._v(" "), _vm._m(17, false, false), _vm._v(" "), _vm._m(18, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.shippingFee))])])]), _vm._v(" "), _vm._m(19, false, false), _vm._v(" "), _vm._m(20, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.paymentFee))])])]), _vm._v(" "), _vm._m(21, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.invoiceFee))])])]), _vm._v(" "), _vm._m(22, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-3"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.totalAmount))])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingFee),
      expression: "shippingFee"
    }],
    attrs: {
      "type": "hidden",
      "name": "shippingFee"
    },
    domProps: {
      "value": (_vm.shippingFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingFee = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceFee),
      expression: "invoiceFee"
    }],
    attrs: {
      "type": "hidden",
      "name": "invoiceFee"
    },
    domProps: {
      "value": (_vm.invoiceFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoiceFee = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstbuy),
      expression: "firstbuy"
    }],
    attrs: {
      "type": "hidden",
      "name": "firstbuy"
    },
    domProps: {
      "value": (_vm.firstbuy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstbuy = $event.target.value
      }
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("收件人資訊")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label input_required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userEmail),
      expression: "userEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.userEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(23, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("電話")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UserPhone),
      expression: "UserPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.UserPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.UserPhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputCoAdd"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countyval),
      expression: "countyval"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "county"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countyval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.county), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value,
        "selected": option.val == _vm.countyval
      }
    }, [_vm._v("\n                                          " + _vm._s(option.text) + "\n                                      ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.districtval),
      expression: "districtval"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "district"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.districtval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.district), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value,
        "selected": option.val == _vm.districtval
      }
    }, [_vm._v("\n                                          " + _vm._s(option.text) + "\n                                      ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UserAddress),
      expression: "UserAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "address"
    },
    domProps: {
      "value": (_vm.UserAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.UserAddress = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    attrs: {
      "type": "hidden",
      "name": "use_cash"
    },
    domProps: {
      "value": (_vm.discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    attrs: {
      "type": "hidden",
      "name": "token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userID),
      expression: "userID"
    }],
    attrs: {
      "type": "hidden",
      "name": "id"
    },
    domProps: {
      "value": (_vm.userID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "title"
  }, [_vm._v("備註")]), _vm._v(" "), _vm._m(24, false, false), _vm._v(" "), _c('h5', {
    staticClass: "title"
  }, [_vm._v("注意事項")]), _vm._v(" "), _vm._m(25, false, false), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": this.flag
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_vm._v("送出")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("購物車")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("訂購商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step_list text-center"
  }, [_c('ol', {
    staticClass: "list-inline step hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1. 購物明細")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2. 付款方式")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3. 完成訂購")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_c('span', {
    staticClass: "label label-default"
  }, [_vm._v("物流方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_c('span', {
    staticClass: "label label-default"
  }, [_vm._v("發票開立方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("統一編號")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "invoice_number"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("抬頭")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "invoice_company"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart_head"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 hidden-xs"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("商品圖片")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-3"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("商品名稱")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("單價")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("點數")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("數量")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("點數小計")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("單價小計")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("刪除")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-6"
  }, [_c('p', [_vm._v("小計")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-5 col-sm-2 text-right hidden-xs"
  }, [_c('p', [_vm._v("(運費類型)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-xs-6"
  }, [_c('p', [_vm._v("運費")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-6"
  }, [_c('p', [_vm._v("稅金")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-6"
  }, [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("總計")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "notice_list"
  }, [_c('li', [_vm._v("請確認您填寫的資料是否正確，一旦訂單完成後，付款與物流方式皆無法修改。")]), _vm._v(" "), _c('li', [_vm._v("出貨方式，按照訂購區域與時間，依序進行出貨/排貨。")]), _vm._v(" "), _c('li', [_vm._v("若您對取貨或付款的方式有疑問，請詳閱「購物須知」。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart_head"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 hidden-xs"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("商品圖片")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-3"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("商品名稱")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("單價")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("點數")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 col-xs-1"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("數量")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("點數小計")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-2"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("單價小計")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-4"
  }, [_c('p', [_vm._v("小計")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-4"
  }, [_c('p', [_vm._v("回饋金折抵")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-5 col-sm-2 hidden-xs text-right"
  }, [_c('p', [_vm._v("(運費類型)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-xs-4"
  }, [_c('p', [_vm._v("運費")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-5 col-sm-2 hidden-xs text-right"
  }, [_c('p', [_vm._v("(金流類型)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-xs-4"
  }, [_c('p', [_vm._v("手續費")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-4"
  }, [_c('p', [_vm._v("稅金")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-7 col-sm-2 col-xs-3"
  }, [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("總計")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputTime"
    }
  }, [_vm._v("配送時間")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "time"
    }
  }, [_c('option', {
    attrs: {
      "value": "不限時間"
    }
  }, [_vm._v("不限時間")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "上午"
    }
  }, [_vm._v("上午")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "下午"
    }
  }, [_vm._v("下午")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "name": "remark",
      "placeholder": "備註",
      "rows": "5"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "notice_list"
  }, [_c('li', [_vm._v("請確認您填寫的資料是否正確，一旦訂單完成後，付款與物流方式皆無法修改。")]), _vm._v(" "), _c('li', [_vm._v("出貨方式，按照訂購區域與時間，依序進行出貨/排貨。")]), _vm._v(" "), _c('li', [_vm._v("若您對取貨或付款的方式有疑問，請洽本公司客服電話。")])])
}]}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("關於我們")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("內容")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("關於我們")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "active item"
  }, [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("關於我們")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("我們的會員")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("隱私權政策")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('article', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("關於i80")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                        i80諧音取自「愛幫您」這個緣起於愛，我們以愛為出發點，即我幫您-您幫我。\n我們設計的不只是平台而是一種架構，在我們架構裡，沒有貧窮，也沒有人會失業，我們讓「失業與貧窮」這個詞失去意義。人不應該到企業去找工作，應該是給人工作的人。所有的人都是創業家，我們創造了更新、更好的體系。因為創業精神是人的基本特質。\n我們的宗旨就「讓每一個人都成為自己時間的主人，過自己想要的生活，做自己喜歡的事情，賺自己需要財富！」。\n                      "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("我們要如何做到?")]), _vm._v(" 我們透過店家的串聯成為一個大商圈，將消費者集結成聯盟，並創建人人都是老闆的平台。\n                      要改變傳統產業利潤分配模式，我們需要同舟共濟一起合作，相互進行商圈宣傳及舉辦活動，創造消費者和店家雙贏的局面。\n                      "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("我們該如何合作?")]), _vm._v("\n                      如果你認同我們的理念，請將我們的理念介紹給親友，讓他加入我們成為會員，成為消費者聯盟的一份子。成為會員後，到聯盟的商店購買產品即有回饋點數。\n                    ")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/PQtCtw3DP4w",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])])])])])
}]}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('h4', [_vm._v("您的訂購已完成，請至會員中心查詢訂購紀錄")]), _vm._v(" "), _c('center', {
    staticClass: "success_block"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "success_product_title"
  }, [_vm._v("您將獲得免費贈送活動")]), _vm._v(" "), (_vm.firstbuy == 0) ? _c('section', [_c('p', {
    staticClass: "success_description"
  })]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "success_product_name"
  }, [_vm._v(_vm._s(_vm.rowData.name))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "label label-default"
  }, [_vm._v("\n                        馬上分享 : https://www.i80.com.tw/product/" + _vm._s(_vm.activityItem) + "/" + _vm._s(_vm.UserId) + "\n                      ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.shareLink,
      "title": "i80",
      "description": "i80",
      "hashtags": "i80"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fab fa-facebook fa-2x"
          }), _vm._v(" Facebook\n                          ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "line"
            }
          }, [_c('i', {
            staticClass: "fab fa-line fa-2x"
          }), _vm._v(" Line\n                          ")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#exampleModalCenter"
    }
  }, [_vm._v("\n  了解詳情\n")]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModalCenter",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("活動訊息")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n        愛幫您的會員您好，只要按下分享愛幫您將贈送給您免費商品。"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")])])])])]), _vm._v(" "), _c('br')])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("線上訂購")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("訂購完成")])])
}]}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("會員條款")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("會員條款")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("隱私權政策")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "/member_policy"
    }
  }, [_vm._v("會員條款")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('h3', {
    staticClass: "title hidden-xs hidden-sm"
  }, [_vm._v("會員條款")]), _vm._v(" "), _c('div', {
    staticClass: "editor"
  }, [_c('p', [_vm._v("\n                      愛幫您股份有限公司之會員，以下簡稱 i80 會員， i80 會員享有各合作商家經營的商品及服務優惠，及經營組織會員之權利，以下為不同會員級別的權利與義務\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                      一、一般會員："), _c('br'), _vm._v("\n                      1、免費註冊享終身折扣優惠並回饋 12 ％ 點數"), _c('br'), _vm._v("\n                      2、會員取得之點數僅供愛幫您股份有限公司平台內使用\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                      二、分享會員："), _c('br'), _vm._v("\n                      １、必須符合會員身分。"), _c('br'), _vm._v("\n                      ２、必須參加經營者會員培訓。"), _c('br'), _vm._v("\n                      ３、組織回饋的 50％ 產品，50 ％點數，個人必須有消費方可領取點數。"), _c('br'), _vm._v("\n                      ４、每月必須達，消費 500 點以上(因消費結算方式有點數上的落差，請至 -> 回饋金查詢 -> 總點數，計算結果為準)，才能具有維持經營組織權，若未達消費門檻，原本推薦組織將不再列入您的會員帳號下。"), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                      三、以上會員資格公司保有修改條款權利\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                      四、一般會員以及分享會員，若違反愛幫您之規定或影響公司商譽等，愛幫您股份有限公司有權立即停止該帳戶、組織以及福利。\n                    ")])])])])])])])
}]}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('center', [_c('form', {
    staticClass: "navbar-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "catalog"
    }
  }, _vm._l((_vm.catalog), function(option) {
    return _c('option', {
      domProps: {
        "value": option.text
      }
    }, [_vm._v("\n                            " + _vm._s(option.text) + "\n                        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入產品名稱"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.ProductSearch()
      }
    }
  }, [_vm._v("查詢")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, _vm._l((_vm.productList), function(item, index) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "product_box"
    }, [_c('figure', {
      staticClass: "pic justify"
    }, [_c('a', {
      attrs: {
        "href": '/product/' + item.id
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageM
      }
    })])]), _vm._v(" "), _c('center', [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.price > 0) ? _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))]) : _vm._e(), _vm._v(" "), (item.price > 0 && item.point) ? _c('span', {
      staticClass: "points"
    }, [_vm._v(_vm._s(item.point) + "點")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "addcart btn btn-default i80_btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.addToCart(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-shopping-cart",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" 加入購物車\n                        ")])])], 1)])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_vm._v("商品")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("商品列表")])])
}]}

/***/ }),
/* 317 */,
/* 318 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[154]);


// WEBPACK FOOTER //
// static/js/app.59e6a3c1901f8c36c17a.js